// 地区数据 + 坐标（由后端 area_domestic.json / area_overseas.json 生成，勿手改）
// 数据源：overseasapi MingliAlgorithm/MingliCore/src/main/resources/

export type BirthPlaceTree = Record<string, Record<string, string[]>>;

export const DOMESTIC_AREA: Record<string, Record<string, string[]>> = {
  "北京市": {
    "北京市": ["东城区", "西城区", "朝阳区", "丰台区", "石景山区", "海淀区", "门头沟区", "房山区", "通州区", "顺义区", "昌平区", "大兴区", "怀柔区", "平谷区", "密云区", "延庆区"],
  },
  "天津市": {
    "天津市": ["和平区", "河东区", "河西区", "南开区", "河北区", "红桥区", "东丽区", "西青区", "津南区", "北辰区", "武清区", "宝坻区", "滨海新区", "宁河区", "静海区", "蓟州区"],
  },
  "河北省": {
    "石家庄市": ["长安区", "桥西区", "新华区", "井陉矿区", "裕华区", "藁城区", "鹿泉区", "栾城区", "井陉县", "正定县", "行唐县", "灵寿县", "高邑县", "深泽县", "赞皇县", "无极县", "平山县", "元氏县", "赵县", "辛集市", "晋州市", "新乐市"],
    "唐山市": ["路南区", "路北区", "古冶区", "开平区", "丰南区", "丰润区", "曹妃甸区", "滦南县", "乐亭县", "迁西县", "玉田县", "遵化市", "迁安市", "滦州市"],
    "秦皇岛市": ["海港区", "山海关区", "北戴河区", "抚宁区", "青龙满族自治县", "昌黎县", "卢龙县"],
    "邯郸市": ["邯山区", "丛台区", "复兴区", "峰峰矿区", "肥乡区", "永年区", "临漳县", "成安县", "大名县", "涉县", "磁县", "邱县", "鸡泽县", "广平县", "馆陶县", "魏县", "曲周县", "武安市"],
    "邢台市": ["襄都区", "信都区", "任泽区", "南和区", "临城县", "内丘县", "柏乡县", "隆尧县", "宁晋县", "巨鹿县", "新河县", "广宗县", "平乡县", "威县", "清河县", "临西县", "南宫市", "沙河市"],
    "保定市": ["竞秀区", "莲池区", "满城区", "清苑区", "徐水区", "涞水县", "阜平县", "定兴县", "唐县", "高阳县", "容城县", "涞源县", "望都县", "安新县", "易县", "曲阳县", "蠡县", "顺平县", "博野县", "雄县", "涿州市", "定州市", "安国市", "高碑店市"],
    "张家口市": ["桥东区", "桥西区", "宣化区", "下花园区", "万全区", "崇礼区", "张北县", "康保县", "沽源县", "尚义县", "蔚县", "阳原县", "怀安县", "怀来县", "涿鹿县", "赤城县"],
    "承德市": ["双桥区", "双滦区", "鹰手营子矿区", "承德县", "兴隆县", "滦平县", "隆化县", "丰宁满族自治县", "宽城满族自治县", "围场满族蒙古族自治县", "平泉市"],
    "沧州市": ["新华区", "运河区", "沧县", "青县", "东光县", "海兴县", "盐山县", "肃宁县", "南皮县", "吴桥县", "献县", "孟村回族自治县", "泊头市", "任丘市", "黄骅市", "河间市"],
    "廊坊市": ["安次区", "广阳区", "固安县", "永清县", "香河县", "大城县", "文安县", "大厂回族自治县", "霸州市", "三河市"],
    "衡水市": ["桃城区", "冀州区", "枣强县", "武邑县", "武强县", "饶阳县", "安平县", "故城县", "景县", "阜城县", "深州市"],
  },
  "山西省": {
    "太原市": ["小店区", "迎泽区", "杏花岭区", "尖草坪区", "万柏林区", "晋源区", "清徐县", "阳曲县", "娄烦县", "古交市"],
    "大同市": ["新荣区", "平城区", "云冈区", "云州区", "阳高县", "天镇县", "广灵县", "灵丘县", "浑源县", "左云县"],
    "阳泉市": ["城区", "矿区", "郊区", "平定县", "盂县"],
    "长治市": ["潞州区", "上党区", "屯留区", "潞城区", "襄垣县", "平顺县", "黎城县", "壶关县", "长子县", "武乡县", "沁县", "沁源县"],
    "晋城市": ["城区", "沁水县", "阳城县", "陵川县", "泽州县", "高平市"],
    "朔州市": ["朔城区", "平鲁区", "山阴县", "应县", "右玉县", "怀仁市"],
    "晋中市": ["榆次区", "太谷区", "榆社县", "左权县", "和顺县", "昔阳县", "寿阳县", "祁县", "平遥县", "灵石县", "介休市"],
    "运城市": ["盐湖区", "临猗县", "万荣县", "闻喜县", "稷山县", "新绛县", "绛县", "垣曲县", "夏县", "平陆县", "芮城县", "永济市", "河津市"],
    "忻州市": ["忻府区", "定襄县", "五台县", "代县", "繁峙县", "宁武县", "静乐县", "神池县", "五寨县", "岢岚县", "河曲县", "保德县", "偏关县", "原平市"],
    "临汾市": ["尧都区", "曲沃县", "翼城县", "襄汾县", "洪洞县", "古县", "安泽县", "浮山县", "吉县", "乡宁县", "大宁县", "隰县", "永和县", "蒲县", "汾西县", "侯马市", "霍州市"],
    "吕梁市": ["离石区", "文水县", "交城县", "兴县", "临县", "柳林县", "石楼县", "岚县", "方山县", "中阳县", "交口县", "孝义市", "汾阳市"],
  },
  "内蒙古自治区": {
    "呼和浩特市": ["新城区", "回民区", "玉泉区", "赛罕区", "土默特左旗", "托克托县", "和林格尔县", "清水河县", "武川县"],
    "包头市": ["东河区", "昆都仑区", "青山区", "石拐区", "白云鄂博矿区", "九原区", "土默特右旗", "固阳县", "达尔罕茂明安联合旗"],
    "乌海市": ["海勃湾区", "海南区", "乌达区"],
    "赤峰市": ["红山区", "元宝山区", "松山区", "阿鲁科尔沁旗", "巴林左旗", "巴林右旗", "林西县", "克什克腾旗", "翁牛特旗", "喀喇沁旗", "宁城县", "敖汉旗"],
    "通辽市": ["科尔沁区", "科尔沁左翼中旗", "科尔沁左翼后旗", "开鲁县", "库伦旗", "奈曼旗", "扎鲁特旗", "霍林郭勒市"],
    "鄂尔多斯市": ["东胜区", "康巴什区", "达拉特旗", "准格尔旗", "鄂托克前旗", "鄂托克旗", "杭锦旗", "乌审旗", "伊金霍洛旗"],
    "呼伦贝尔市": ["海拉尔区", "扎赉诺尔区", "阿荣旗", "莫力达瓦达斡尔族自治旗", "鄂伦春自治旗", "鄂温克族自治旗", "陈巴尔虎旗", "新巴尔虎左旗", "新巴尔虎右旗", "满洲里市", "牙克石市", "扎兰屯市", "额尔古纳市", "根河市"],
    "巴彦淖尔市": ["临河区", "五原县", "磴口县", "乌拉特前旗", "乌拉特中旗", "乌拉特后旗", "杭锦后旗"],
    "乌兰察布市": ["集宁区", "卓资县", "化德县", "商都县", "兴和县", "凉城县", "察哈尔右翼前旗", "察哈尔右翼中旗", "察哈尔右翼后旗", "四子王旗", "丰镇市"],
    "兴安盟": ["乌兰浩特市", "阿尔山市", "科尔沁右翼前旗", "科尔沁右翼中旗", "扎赉特旗", "突泉县"],
    "锡林郭勒盟": ["二连浩特市", "锡林浩特市", "阿巴嘎旗", "苏尼特左旗", "苏尼特右旗", "东乌珠穆沁旗", "西乌珠穆沁旗", "太仆寺旗", "镶黄旗", "正镶白旗", "正蓝旗", "多伦县"],
    "阿拉善盟": ["阿拉善左旗", "阿拉善右旗", "额济纳旗"],
  },
  "辽宁省": {
    "沈阳市": ["和平区", "沈河区", "大东区", "皇姑区", "铁西区", "苏家屯区", "浑南区", "沈北新区", "于洪区", "辽中区", "康平县", "法库县", "新民市"],
    "大连市": ["中山区", "西岗区", "沙河口区", "甘井子区", "旅顺口区", "金州区", "普兰店区", "长海县", "瓦房店市", "庄河市"],
    "鞍山市": ["铁东区", "铁西区", "立山区", "千山区", "台安县", "岫岩满族自治县", "海城市"],
    "抚顺市": ["新抚区", "东洲区", "望花区", "顺城区", "抚顺县", "新宾满族自治县", "清原满族自治县"],
    "本溪市": ["平山区", "溪湖区", "明山区", "南芬区", "本溪满族自治县", "桓仁满族自治县"],
    "丹东市": ["元宝区", "振兴区", "振安区", "宽甸满族自治县", "东港市", "凤城市"],
    "锦州市": ["古塔区", "凌河区", "太和区", "黑山县", "义县", "凌海市", "北镇市"],
    "营口市": ["站前区", "西市区", "鲅鱼圈区", "老边区", "盖州市", "大石桥市"],
    "阜新市": ["海州区", "新邱区", "太平区", "清河门区", "细河区", "阜新蒙古族自治县", "彰武县"],
    "辽阳市": ["白塔区", "文圣区", "宏伟区", "弓长岭区", "太子河区", "辽阳县", "灯塔市"],
    "盘锦市": ["双台子区", "兴隆台区", "大洼区", "盘山县"],
    "铁岭市": ["银州区", "清河区", "铁岭县", "西丰县", "昌图县", "调兵山市", "开原市"],
    "朝阳市": ["双塔区", "龙城区", "朝阳县", "建平县", "喀喇沁左翼蒙古族自治县", "北票市", "凌源市"],
    "葫芦岛市": ["连山区", "龙港区", "南票区", "绥中县", "建昌县", "兴城市"],
    "金普新区": ["金州新区", "普湾新区", "保税区"],
  },
  "吉林省": {
    "长春市": ["公主岭市", "南关区", "宽城区", "朝阳区", "二道区", "绿园区", "双阳区", "九台区", "农安县", "榆树市", "德惠市"],
    "吉林市": ["昌邑区", "龙潭区", "船营区", "丰满区", "永吉县", "蛟河市", "桦甸市", "舒兰市", "磐石市"],
    "四平市": ["铁西区", "铁东区", "梨树县", "伊通满族自治县", "双辽市"],
    "辽源市": ["龙山区", "西安区", "东丰县", "东辽县"],
    "通化市": ["东昌区", "二道江区", "通化县", "辉南县", "柳河县", "梅河口市", "集安市"],
    "白山市": ["浑江区", "江源区", "抚松县", "靖宇县", "长白朝鲜族自治县", "临江市"],
    "松原市": ["宁江区", "前郭尔罗斯蒙古族自治县", "长岭县", "乾安县", "扶余市"],
    "白城市": ["洮北区", "镇赉县", "通榆县", "洮南市", "大安市"],
    "延边朝鲜族自治州": ["延吉市", "图们市", "敦化市", "珲春市", "龙井市", "和龙市", "汪清县", "安图县"],
  },
  "黑龙江省": {
    "哈尔滨市": ["道里区", "南岗区", "道外区", "平房区", "松北区", "香坊区", "呼兰区", "阿城区", "双城区", "依兰县", "方正县", "宾县", "巴彦县", "木兰县", "通河县", "延寿县", "尚志市", "五常市"],
    "齐齐哈尔市": ["龙沙区", "建华区", "铁锋区", "昂昂溪区", "富拉尔基区", "碾子山区", "梅里斯达斡尔族区", "龙江县", "依安县", "泰来县", "甘南县", "富裕县", "克山县", "克东县", "拜泉县", "讷河市"],
    "鸡西市": ["鸡冠区", "恒山区", "滴道区", "梨树区", "城子河区", "麻山区", "鸡东县", "虎林市", "密山市"],
    "鹤岗市": ["向阳区", "工农区", "南山区", "兴安区", "东山区", "兴山区", "萝北县", "绥滨县"],
    "双鸭山市": ["尖山区", "岭东区", "四方台区", "宝山区", "集贤县", "友谊县", "宝清县", "饶河县"],
    "大庆市": ["萨尔图区", "龙凤区", "让胡路区", "红岗区", "大同区", "肇州县", "肇源县", "林甸县", "杜尔伯特蒙古族自治县"],
    "伊春市": ["伊美区", "乌翠区", "友好区", "嘉荫县", "汤旺县", "丰林县", "大箐山县", "南岔县", "金林区", "铁力市"],
    "佳木斯市": ["向阳区", "前进区", "东风区", "郊区", "桦南县", "桦川县", "汤原县", "同江市", "富锦市", "抚远市"],
    "七台河市": ["新兴区", "桃山区", "茄子河区", "勃利县"],
    "牡丹江市": ["东安区", "阳明区", "爱民区", "西安区", "林口县", "绥芬河市", "海林市", "宁安市", "穆棱市", "东宁市"],
    "黑河市": ["爱辉区", "逊克县", "孙吴县", "北安市", "五大连池市", "嫩江市"],
    "绥化市": ["北林区", "望奎县", "兰西县", "青冈县", "庆安县", "明水县", "绥棱县", "安达市", "肇东市", "海伦市"],
    "大兴安岭地区": ["漠河市", "呼玛县", "塔河县"],
  },
  "上海市": {
    "上海市": ["黄浦区", "徐汇区", "长宁区", "静安区", "普陀区", "虹口区", "杨浦区", "闵行区", "宝山区", "嘉定区", "浦东新区", "金山区", "松江区", "青浦区", "奉贤区", "崇明区"],
  },
  "江苏省": {
    "南京市": ["玄武区", "秦淮区", "建邺区", "鼓楼区", "浦口区", "栖霞区", "雨花台区", "江宁区", "六合区", "溧水区", "高淳区"],
    "无锡市": ["锡山区", "惠山区", "滨湖区", "梁溪区", "新吴区", "江阴市", "宜兴市"],
    "徐州市": ["鼓楼区", "云龙区", "贾汪区", "泉山区", "铜山区", "丰县", "沛县", "睢宁县", "新沂市", "邳州市"],
    "常州市": ["天宁区", "钟楼区", "新北区", "武进区", "金坛区", "溧阳市"],
    "苏州市": ["虎丘区", "吴中区", "相城区", "姑苏区", "吴江区", "常熟市", "张家港市", "昆山市", "太仓市"],
    "南通市": ["通州区", "崇川区", "海门区", "如东县", "启东市", "如皋市", "海安市"],
    "连云港市": ["连云区", "海州区", "赣榆区", "东海县", "灌云县", "灌南县"],
    "淮安市": ["淮安区", "淮阴区", "清江浦区", "洪泽区", "涟水县", "盱眙县", "金湖县"],
    "盐城市": ["亭湖区", "盐都区", "大丰区", "响水县", "滨海县", "阜宁县", "射阳县", "建湖县", "东台市"],
    "扬州市": ["广陵区", "邗江区", "江都区", "宝应县", "仪征市", "高邮市"],
    "镇江市": ["京口区", "润州区", "丹徒区", "丹阳市", "扬中市", "句容市"],
    "泰州市": ["海陵区", "高港区", "姜堰区", "兴化市", "靖江市", "泰兴市"],
    "宿迁市": ["宿城区", "宿豫区", "沭阳县", "泗阳县", "泗洪县"],
  },
  "浙江省": {
    "杭州市": ["上城区", "拱墅区", "西湖区", "滨江区", "萧山区", "余杭区", "富阳区", "临安区", "临平区", "钱塘区", "桐庐县", "淳安县", "建德市"],
    "宁波市": ["海曙区", "江北区", "北仑区", "镇海区", "鄞州区", "奉化区", "象山县", "宁海县", "余姚市", "慈溪市"],
    "温州市": ["鹿城区", "龙湾区", "瓯海区", "洞头区", "永嘉县", "平阳县", "苍南县", "文成县", "泰顺县", "瑞安市", "乐清市", "龙港市"],
    "嘉兴市": ["南湖区", "秀洲区", "嘉善县", "海盐县", "海宁市", "平湖市", "桐乡市"],
    "湖州市": ["吴兴区", "南浔区", "德清县", "长兴县", "安吉县"],
    "绍兴市": ["越城区", "柯桥区", "上虞区", "新昌县", "诸暨市", "嵊州市"],
    "金华市": ["婺城区", "金东区", "武义县", "浦江县", "磐安县", "兰溪市", "义乌市", "东阳市", "永康市"],
    "衢州市": ["柯城区", "衢江区", "常山县", "开化县", "龙游县", "江山市"],
    "舟山市": ["定海区", "普陀区", "岱山县", "嵊泗县"],
    "台州市": ["椒江区", "黄岩区", "路桥区", "三门县", "天台县", "仙居县", "温岭市", "临海市", "玉环市"],
    "丽水市": ["莲都区", "青田县", "缙云县", "遂昌县", "松阳县", "云和县", "庆元县", "景宁畲族自治县", "龙泉市"],
    "舟山群岛新区": ["金塘岛", "六横岛", "衢山岛", "舟山本岛西北部", "岱山岛西南部", "泗礁岛", "朱家尖岛", "洋山岛", "长涂岛", "虾峙岛"],
  },
  "安徽省": {
    "合肥市": ["瑶海区", "庐阳区", "蜀山区", "包河区", "长丰县", "肥东县", "肥西县", "庐江县", "巢湖市"],
    "芜湖市": ["镜湖区", "鸠江区", "弋江区", "湾沚区", "繁昌区", "南陵县", "无为市"],
    "蚌埠市": ["龙子湖区", "蚌山区", "禹会区", "淮上区", "怀远县", "五河县", "固镇县"],
    "淮南市": ["大通区", "田家庵区", "谢家集区", "八公山区", "潘集区", "凤台县", "寿县"],
    "马鞍山市": ["花山区", "雨山区", "博望区", "当涂县", "含山县", "和县"],
    "淮北市": ["杜集区", "相山区", "烈山区", "濉溪县"],
    "铜陵市": ["铜官区", "义安区", "郊区", "枞阳县"],
    "安庆市": ["迎江区", "大观区", "宜秀区", "怀宁县", "太湖县", "宿松县", "望江县", "岳西县", "桐城市", "潜山市"],
    "黄山市": ["屯溪区", "黄山区", "徽州区", "歙县", "休宁县", "黟县", "祁门县"],
    "滁州市": ["琅琊区", "南谯区", "来安县", "全椒县", "定远县", "凤阳县", "天长市", "明光市"],
    "阜阳市": ["颍州区", "颍东区", "颍泉区", "临泉县", "太和县", "阜南县", "颍上县", "界首市"],
    "宿州市": ["埇桥区", "砀山县", "萧县", "灵璧县", "泗县"],
    "六安市": ["金安区", "裕安区", "叶集区", "霍邱县", "舒城县", "金寨县", "霍山县"],
    "亳州市": ["谯城区", "涡阳县", "蒙城县", "利辛县"],
    "池州市": ["贵池区", "东至县", "石台县", "青阳县"],
    "宣城市": ["宣州区", "郎溪县", "泾县", "绩溪县", "旌德县", "宁国市", "广德市"],
  },
  "福建省": {
    "福州市": ["鼓楼区", "台江区", "仓山区", "马尾区", "晋安区", "长乐区", "闽侯县", "连江县", "罗源县", "闽清县", "永泰县", "平潭县", "福清市"],
    "厦门市": ["思明区", "海沧区", "湖里区", "集美区", "同安区", "翔安区"],
    "莆田市": ["城厢区", "涵江区", "荔城区", "秀屿区", "仙游县"],
    "三明市": ["三元区", "沙县区", "明溪县", "清流县", "宁化县", "大田县", "尤溪县", "将乐县", "泰宁县", "建宁县", "永安市"],
    "泉州市": ["鲤城区", "丰泽区", "洛江区", "泉港区", "惠安县", "安溪县", "永春县", "德化县", "金门县", "石狮市", "晋江市", "南安市"],
    "漳州市": ["芗城区", "龙文区", "龙海区", "长泰区", "云霄县", "漳浦县", "诏安县", "东山县", "南靖县", "平和县", "华安县"],
    "南平市": ["延平区", "建阳区", "顺昌县", "浦城县", "光泽县", "松溪县", "政和县", "邵武市", "武夷山市", "建瓯市"],
    "龙岩市": ["新罗区", "永定区", "长汀县", "上杭县", "武平县", "连城县", "漳平市"],
    "宁德市": ["蕉城区", "霞浦县", "古田县", "屏南县", "寿宁县", "周宁县", "柘荣县", "福安市", "福鼎市"],
  },
  "江西省": {
    "南昌市": ["东湖区", "西湖区", "青云谱区", "青山湖区", "新建区", "红谷滩区", "南昌县", "安义县", "进贤县"],
    "景德镇市": ["昌江区", "珠山区", "浮梁县", "乐平市"],
    "萍乡市": ["安源区", "湘东区", "莲花县", "上栗县", "芦溪县"],
    "九江市": ["濂溪区", "浔阳区", "柴桑区", "武宁县", "修水县", "永修县", "德安县", "都昌县", "湖口县", "彭泽县", "瑞昌市", "共青城市", "庐山市"],
    "新余市": ["渝水区", "分宜县"],
    "鹰潭市": ["月湖区", "余江区", "贵溪市"],
    "赣州市": ["章贡区", "南康区", "赣县区", "信丰县", "大余县", "上犹县", "崇义县", "安远县", "定南县", "全南县", "宁都县", "于都县", "兴国县", "会昌县", "寻乌县", "石城县", "瑞金市", "龙南市"],
    "吉安市": ["吉州区", "青原区", "吉安县", "吉水县", "峡江县", "新干县", "永丰县", "泰和县", "遂川县", "万安县", "安福县", "永新县", "井冈山市"],
    "宜春市": ["袁州区", "奉新县", "万载县", "上高县", "宜丰县", "靖安县", "铜鼓县", "丰城市", "樟树市", "高安市"],
    "抚州市": ["临川区", "东乡区", "南城县", "黎川县", "南丰县", "崇仁县", "乐安县", "宜黄县", "金溪县", "资溪县", "广昌县"],
    "上饶市": ["信州区", "广丰区", "广信区", "玉山县", "铅山县", "横峰县", "弋阳县", "余干县", "鄱阳县", "万年县", "婺源县", "德兴市"],
  },
  "山东省": {
    "济南市": ["历下区", "市中区", "槐荫区", "天桥区", "历城区", "长清区", "章丘区", "济阳区", "莱芜区", "钢城区", "平阴县", "商河县"],
    "青岛市": ["市南区", "市北区", "黄岛区", "崂山区", "李沧区", "城阳区", "即墨区", "胶州市", "平度市", "莱西市"],
    "淄博市": ["淄川区", "张店区", "博山区", "临淄区", "周村区", "桓台县", "高青县", "沂源县"],
    "枣庄市": ["市中区", "薛城区", "峄城区", "台儿庄区", "山亭区", "滕州市"],
    "东营市": ["东营区", "河口区", "垦利区", "利津县", "广饶县"],
    "烟台市": ["芝罘区", "福山区", "牟平区", "莱山区", "蓬莱区", "龙口市", "莱阳市", "莱州市", "招远市", "栖霞市", "海阳市"],
    "潍坊市": ["潍城区", "寒亭区", "坊子区", "奎文区", "临朐县", "昌乐县", "青州市", "诸城市", "寿光市", "安丘市", "高密市", "昌邑市"],
    "济宁市": ["任城区", "兖州区", "微山县", "鱼台县", "金乡县", "嘉祥县", "汶上县", "泗水县", "梁山县", "曲阜市", "邹城市"],
    "泰安市": ["泰山区", "岱岳区", "宁阳县", "东平县", "新泰市", "肥城市"],
    "威海市": ["环翠区", "文登区", "荣成市", "乳山市"],
    "日照市": ["东港区", "岚山区", "五莲县", "莒县"],
    "临沂市": ["兰山区", "罗庄区", "河东区", "沂南县", "郯城县", "沂水县", "兰陵县", "费县", "平邑县", "莒南县", "蒙阴县", "临沭县"],
    "德州市": ["德城区", "陵城区", "宁津县", "庆云县", "临邑县", "齐河县", "平原县", "夏津县", "武城县", "乐陵市", "禹城市"],
    "聊城市": ["东昌府区", "茌平区", "阳谷县", "莘县", "东阿县", "冠县", "高唐县", "临清市"],
    "滨州市": ["滨城区", "沾化区", "惠民县", "阳信县", "无棣县", "博兴县", "邹平市"],
    "菏泽市": ["牡丹区", "定陶区", "曹县", "单县", "成武县", "巨野县", "郓城县", "鄄城县", "东明县"],
  },
  "河南省": {
    "郑州市": ["中原区", "二七区", "管城回族区", "金水区", "上街区", "惠济区", "中牟县", "巩义市", "荥阳市", "新密市", "新郑市", "登封市"],
    "开封市": ["龙亭区", "顺河回族区", "鼓楼区", "禹王台区", "祥符区", "杞县", "通许县", "尉氏县", "兰考县"],
    "洛阳市": ["老城区", "西工区", "瀍河回族区", "涧西区", "偃师区", "孟津区", "洛龙区", "新安县", "栾川县", "嵩县", "汝阳县", "宜阳县", "洛宁县", "伊川县"],
    "平顶山市": ["新华区", "卫东区", "石龙区", "湛河区", "宝丰县", "叶县", "鲁山县", "郏县", "舞钢市", "汝州市"],
    "安阳市": ["文峰区", "北关区", "殷都区", "龙安区", "安阳县", "汤阴县", "滑县", "内黄县", "林州市"],
    "鹤壁市": ["鹤山区", "山城区", "淇滨区", "浚县", "淇县"],
    "新乡市": ["红旗区", "卫滨区", "凤泉区", "牧野区", "新乡县", "获嘉县", "原阳县", "延津县", "封丘县", "卫辉市", "辉县市", "长垣市"],
    "焦作市": ["解放区", "中站区", "马村区", "山阳区", "修武县", "博爱县", "武陟县", "温县", "沁阳市", "孟州市"],
    "濮阳市": ["华龙区", "清丰县", "南乐县", "范县", "台前县", "濮阳县"],
    "许昌市": ["魏都区", "建安区", "鄢陵县", "襄城县", "禹州市", "长葛市"],
    "漯河市": ["源汇区", "郾城区", "召陵区", "舞阳县", "临颍县"],
    "三门峡市": ["湖滨区", "陕州区", "渑池县", "卢氏县", "义马市", "灵宝市"],
    "南阳市": ["宛城区", "卧龙区", "南召县", "方城县", "西峡县", "镇平县", "内乡县", "淅川县", "社旗县", "唐河县", "新野县", "桐柏县", "邓州市"],
    "商丘市": ["梁园区", "睢阳区", "民权县", "睢县", "宁陵县", "柘城县", "虞城县", "夏邑县", "永城市"],
    "信阳市": ["浉河区", "平桥区", "罗山县", "光山县", "新县", "商城县", "固始县", "潢川县", "淮滨县", "息县"],
    "周口市": ["川汇区", "淮阳区", "扶沟县", "西华县", "商水县", "沈丘县", "郸城县", "太康县", "鹿邑县", "项城市"],
    "驻马店市": ["驿城区", "西平县", "上蔡县", "平舆县", "正阳县", "确山县", "泌阳县", "汝南县", "遂平县", "新蔡县"],
    "省直辖县级行政区划": ["济源市"],
  },
  "湖北省": {
    "武汉市": ["江岸区", "江汉区", "硚口区", "汉阳区", "武昌区", "青山区", "洪山区", "东西湖区", "汉南区", "蔡甸区", "江夏区", "黄陂区", "新洲区"],
    "黄石市": ["黄石港区", "西塞山区", "下陆区", "铁山区", "阳新县", "大冶市"],
    "十堰市": ["茅箭区", "张湾区", "郧阳区", "郧西县", "竹山县", "竹溪县", "房县", "丹江口市"],
    "宜昌市": ["西陵区", "伍家岗区", "点军区", "猇亭区", "夷陵区", "远安县", "兴山县", "秭归县", "长阳土家族自治县", "五峰土家族自治县", "宜都市", "当阳市", "枝江市"],
    "襄阳市": ["襄城区", "樊城区", "襄州区", "南漳县", "谷城县", "保康县", "老河口市", "枣阳市", "宜城市"],
    "鄂州市": ["梁子湖区", "华容区", "鄂城区"],
    "荆门市": ["东宝区", "掇刀区", "沙洋县", "钟祥市", "京山市"],
    "孝感市": ["孝南区", "孝昌县", "大悟县", "云梦县", "应城市", "安陆市", "汉川市"],
    "荆州市": ["沙市区", "荆州区", "公安县", "江陵县", "石首市", "洪湖市", "松滋市", "监利市"],
    "黄冈市": ["黄州区", "团风县", "红安县", "罗田县", "英山县", "浠水县", "蕲春县", "黄梅县", "麻城市", "武穴市"],
    "咸宁市": ["咸安区", "嘉鱼县", "通城县", "崇阳县", "通山县", "赤壁市"],
    "随州市": ["曾都区", "随县", "广水市"],
    "恩施土家族苗族自治州": ["恩施市", "利川市", "建始县", "巴东县", "宣恩县", "咸丰县", "来凤县", "鹤峰县"],
    "直辖市县": ["仙桃市", "潜江市", "天门市", "神农架林区"],
  },
  "湖南省": {
    "长沙市": ["芙蓉区", "天心区", "岳麓区", "开福区", "雨花区", "望城区", "长沙县", "浏阳市", "宁乡市"],
    "株洲市": ["荷塘区", "芦淞区", "石峰区", "天元区", "渌口区", "攸县", "茶陵县", "炎陵县", "醴陵市"],
    "湘潭市": ["雨湖区", "岳塘区", "湘潭县", "湘乡市", "韶山市"],
    "衡阳市": ["珠晖区", "雁峰区", "石鼓区", "蒸湘区", "南岳区", "衡阳县", "衡南县", "衡山县", "衡东县", "祁东县", "耒阳市", "常宁市"],
    "邵阳市": ["双清区", "大祥区", "北塔区", "新邵县", "邵阳县", "隆回县", "洞口县", "绥宁县", "新宁县", "城步苗族自治县", "武冈市", "邵东市"],
    "岳阳市": ["岳阳楼区", "云溪区", "君山区", "岳阳县", "华容县", "湘阴县", "平江县", "汨罗市", "临湘市"],
    "常德市": ["武陵区", "鼎城区", "安乡县", "汉寿县", "澧县", "临澧县", "桃源县", "石门县", "津市市"],
    "张家界市": ["永定区", "武陵源区", "慈利县", "桑植县"],
    "益阳市": ["资阳区", "赫山区", "南县", "桃江县", "安化县", "沅江市"],
    "郴州市": ["北湖区", "苏仙区", "桂阳县", "宜章县", "永兴县", "嘉禾县", "临武县", "汝城县", "桂东县", "安仁县", "资兴市"],
    "永州市": ["零陵区", "冷水滩区", "东安县", "双牌县", "道县", "江永县", "宁远县", "蓝山县", "新田县", "江华瑶族自治县", "祁阳市"],
    "怀化市": ["鹤城区", "中方县", "沅陵县", "辰溪县", "溆浦县", "会同县", "麻阳苗族自治县", "新晃侗族自治县", "芷江侗族自治县", "靖州苗族侗族自治县", "通道侗族自治县", "洪江市"],
    "娄底市": ["娄星区", "双峰县", "新化县", "冷水江市", "涟源市"],
    "湘西土家族苗族自治州": ["吉首市", "泸溪县", "凤凰县", "花垣县", "保靖县", "古丈县", "永顺县", "龙山县"],
  },
  "广东省": {
    "广州市": ["荔湾区", "越秀区", "海珠区", "天河区", "白云区", "黄埔区", "番禺区", "花都区", "南沙区", "从化区", "增城区"],
    "韶关市": ["武江区", "浈江区", "曲江区", "始兴县", "仁化县", "翁源县", "乳源瑶族自治县", "新丰县", "乐昌市", "南雄市"],
    "深圳市": ["罗湖区", "福田区", "南山区", "宝安区", "龙岗区", "盐田区", "光明区", "坪山区", "龙华区", "大鹏新区"],
    "珠海市": ["香洲区", "斗门区", "金湾区"],
    "汕头市": ["龙湖区", "金平区", "濠江区", "潮阳区", "潮南区", "澄海区", "南澳县"],
    "佛山市": ["禅城区", "南海区", "顺德区", "三水区", "高明区"],
    "江门市": ["蓬江区", "江海区", "新会区", "台山市", "开平市", "鹤山市", "恩平市"],
    "湛江市": ["赤坎区", "霞山区", "坡头区", "麻章区", "遂溪县", "徐闻县", "廉江市", "雷州市", "吴川市"],
    "茂名市": ["茂南区", "电白区", "高州市", "化州市", "信宜市"],
    "肇庆市": ["端州区", "鼎湖区", "高要区", "广宁县", "怀集县", "封开县", "德庆县", "四会市"],
    "惠州市": ["惠城区", "惠阳区", "博罗县", "惠东县", "龙门县"],
    "梅州市": ["梅江区", "梅县区", "大埔县", "丰顺县", "五华县", "平远县", "蕉岭县", "兴宁市"],
    "汕尾市": ["城区", "海丰县", "陆河县", "陆丰市"],
    "河源市": ["源城区", "紫金县", "龙川县", "连平县", "和平县", "东源县"],
    "阳江市": ["江城区", "阳东区", "阳西县", "阳春市"],
    "清远市": ["清城区", "清新区", "佛冈县", "阳山县", "连山壮族瑶族自治县", "连南瑶族自治县", "英德市", "连州市"],
    "东莞市": ["莞城区", "南城区", "万江区", "东城区", "石碣镇", "石龙镇", "茶山镇", "石排镇", "企石镇", "横沥镇", "桥头镇", "谢岗镇", "东坑镇", "常平镇", "寮步镇", "大朗镇", "麻涌镇", "中堂镇", "高埗镇", "樟木头镇", "大岭山镇", "望牛墩镇", "黄江镇", "洪梅镇", "清溪镇", "沙田镇", "道滘镇", "塘厦镇", "虎门镇", "厚街镇", "凤岗镇", "长安镇"],
    "中山市": ["石岐区", "南区", "西区", "五桂山区", "火炬开发区", "黄圃镇", "南头镇", "东凤镇", "阜沙镇", "小榄镇", "东升镇", "古镇镇", "横栏镇", "三角镇", "民众镇", "南朗镇", "港口镇", "大涌镇", "沙溪镇", "三乡镇", "板芙镇", "神湾镇", "坦洲镇"],
    "潮州市": ["湘桥区", "潮安区", "饶平县"],
    "揭阳市": ["榕城区", "揭东区", "揭西县", "惠来县", "普宁市"],
    "云浮市": ["云城区", "云安区", "新兴县", "郁南县", "罗定市"],
  },
  "广西壮族自治区": {
    "南宁市": ["兴宁区", "青秀区", "江南区", "西乡塘区", "良庆区", "邕宁区", "武鸣区", "隆安县", "马山县", "上林县", "宾阳县", "横州市"],
    "柳州市": ["城中区", "鱼峰区", "柳南区", "柳北区", "柳江区", "柳城县", "鹿寨县", "融安县", "融水苗族自治县", "三江侗族自治县", "柳东新区"],
    "桂林市": ["秀峰区", "叠彩区", "象山区", "七星区", "雁山区", "临桂区", "阳朔县", "灵川县", "全州县", "兴安县", "永福县", "灌阳县", "龙胜各族自治县", "资源县", "平乐县", "荔浦市", "恭城瑶族自治县"],
    "梧州市": ["万秀区", "长洲区", "龙圩区", "苍梧县", "藤县", "蒙山县", "岑溪市"],
    "北海市": ["海城区", "银海区", "铁山港区", "合浦县"],
    "防城港市": ["港口区", "防城区", "上思县", "东兴市"],
    "钦州市": ["钦南区", "钦北区", "灵山县", "浦北县"],
    "贵港市": ["港北区", "港南区", "覃塘区", "平南县", "桂平市"],
    "玉林市": ["玉州区", "福绵区", "容县", "陆川县", "博白县", "兴业县", "北流市"],
    "百色市": ["右江区", "田阳区", "田东县", "德保县", "那坡县", "凌云县", "乐业县", "田林县", "西林县", "靖西市", "平果市", "隆林各族自治县"],
    "贺州市": ["八步区", "平桂区", "昭平县", "钟山县", "富川瑶族自治县"],
    "河池市": ["金城江区", "宜州区", "南丹县", "天峨县", "凤山县", "东兰县", "罗城仫佬族自治县", "环江毛南族自治县", "巴马瑶族自治县", "都安瑶族自治县", "大化瑶族自治县"],
    "来宾市": ["兴宾区", "忻城县", "象州县", "武宣县", "金秀瑶族自治县", "合山市"],
    "崇左市": ["江州区", "扶绥县", "宁明县", "龙州县", "大新县", "天等县", "凭祥市"],
  },
  "海南省": {
    "海口市": ["秀英区", "龙华区", "琼山区", "美兰区"],
    "三亚市": ["海棠区", "吉阳区", "天涯区", "崖州区"],
    "三沙市": ["西沙区", "南沙区", "中沙群岛"],
    "直辖市县": ["五指山市", "琼海市", "儋州市", "文昌市", "万宁市", "东方市", "定安县", "屯昌县", "澄迈县", "临高县", "白沙黎族自治县", "昌江黎族自治县", "乐东黎族自治县", "陵水黎族自治县", "保亭黎族苗族自治县", "琼中黎族苗族自治县"],
  },
  "重庆市": {
    "重庆市": ["万州区", "涪陵区", "渝中区", "大渡口区", "江北区", "沙坪坝区", "九龙坡区", "南岸区", "北碚区", "綦江区", "大足区", "渝北区", "巴南区", "黔江区", "长寿区", "江津区", "合川区", "永川区", "南川区", "璧山区", "铜梁区", "潼南区", "荣昌区", "梁平区", "开州区", "武隆区", "两江新区", "城口县", "丰都县", "垫江县", "忠县", "云阳县", "奉节县", "巫山县", "巫溪县", "石柱土家族自治县", "秀山土家族苗族自治县", "酉阳土家族苗族自治县", "彭水苗族土家族自治县"],
  },
  "四川省": {
    "成都市": ["锦江区", "青羊区", "金牛区", "武侯区", "成华区", "龙泉驿区", "青白江区", "新都区", "温江区", "双流区", "郫都区", "新津区", "金堂县", "大邑县", "蒲江县", "都江堰市", "彭州市", "邛崃市", "崇州市", "简阳市"],
    "自贡市": ["自流井区", "贡井区", "大安区", "沿滩区", "荣县", "富顺县"],
    "攀枝花市": ["东区", "西区", "仁和区", "米易县", "盐边县"],
    "泸州市": ["江阳区", "纳溪区", "龙马潭区", "泸县", "合江县", "叙永县", "古蔺县"],
    "德阳市": ["旌阳区", "罗江区", "中江县", "广汉市", "什邡市", "绵竹市"],
    "绵阳市": ["涪城区", "游仙区", "安州区", "三台县", "盐亭县", "梓潼县", "北川羌族自治县", "平武县", "江油市"],
    "广元市": ["利州区", "昭化区", "朝天区", "旺苍县", "青川县", "剑阁县", "苍溪县"],
    "遂宁市": ["船山区", "安居区", "蓬溪县", "大英县", "射洪市"],
    "内江市": ["市中区", "东兴区", "威远县", "资中县", "隆昌市"],
    "乐山市": ["市中区", "沙湾区", "五通桥区", "金口河区", "犍为县", "井研县", "夹江县", "沐川县", "峨边彝族自治县", "马边彝族自治县", "峨眉山市"],
    "南充市": ["顺庆区", "高坪区", "嘉陵区", "南部县", "营山县", "蓬安县", "仪陇县", "西充县", "阆中市"],
    "眉山市": ["东坡区", "彭山区", "仁寿县", "洪雅县", "丹棱县", "青神县"],
    "宜宾市": ["翠屏区", "南溪区", "叙州区", "江安县", "长宁县", "高县", "珙县", "筠连县", "兴文县", "屏山县"],
    "广安市": ["广安区", "前锋区", "岳池县", "武胜县", "邻水县", "华蓥市"],
    "达州市": ["通川区", "达川区", "宣汉县", "开江县", "大竹县", "渠县", "万源市"],
    "雅安市": ["雨城区", "名山区", "荥经县", "汉源县", "石棉县", "天全县", "芦山县", "宝兴县"],
    "巴中市": ["巴州区", "恩阳区", "通江县", "南江县", "平昌县"],
    "资阳市": ["雁江区", "安岳县", "乐至县"],
    "阿坝藏族羌族自治州": ["马尔康市", "汶川县", "理县", "茂县", "松潘县", "九寨沟县", "金川县", "小金县", "黑水县", "壤塘县", "阿坝县", "若尔盖县", "红原县"],
    "甘孜藏族自治州": ["康定市", "泸定县", "丹巴县", "九龙县", "雅江县", "道孚县", "炉霍县", "甘孜县", "新龙县", "德格县", "白玉县", "石渠县", "色达县", "理塘县", "巴塘县", "乡城县", "稻城县", "得荣县"],
    "凉山彝族自治州": ["西昌市", "会理市", "木里藏族自治县", "盐源县", "德昌县", "会东县", "宁南县", "普格县", "布拖县", "金阳县", "昭觉县", "喜德县", "冕宁县", "越西县", "甘洛县", "美姑县", "雷波县"],
  },
  "贵州省": {
    "贵阳市": ["南明区", "云岩区", "花溪区", "乌当区", "白云区", "观山湖区", "开阳县", "息烽县", "修文县", "清镇市"],
    "六盘水市": ["钟山区", "六枝特区", "水城区", "盘州市"],
    "遵义市": ["红花岗区", "汇川区", "播州区", "桐梓县", "绥阳县", "正安县", "道真仡佬族苗族自治县", "务川仡佬族苗族自治县", "凤冈县", "湄潭县", "余庆县", "习水县", "赤水市", "仁怀市"],
    "安顺市": ["西秀区", "平坝区", "普定县", "镇宁布依族苗族自治县", "关岭布依族苗族自治县", "紫云苗族布依族自治县"],
    "毕节市": ["七星关区", "大方县", "金沙县", "织金县", "纳雍县", "威宁彝族回族苗族自治县", "赫章县", "黔西市"],
    "铜仁市": ["碧江区", "万山区", "江口县", "玉屏侗族自治县", "石阡县", "思南县", "印江土家族苗族自治县", "德江县", "沿河土家族自治县", "松桃苗族自治县"],
    "黔西南布依族苗族自治州": ["兴义市", "兴仁市", "普安县", "晴隆县", "贞丰县", "望谟县", "册亨县", "安龙县"],
    "黔东南苗族侗族自治州": ["凯里市", "黄平县", "施秉县", "三穗县", "镇远县", "岑巩县", "天柱县", "锦屏县", "剑河县", "台江县", "黎平县", "榕江县", "从江县", "雷山县", "麻江县", "丹寨县"],
    "黔南布依族苗族自治州": ["都匀市", "福泉市", "荔波县", "贵定县", "瓮安县", "独山县", "平塘县", "罗甸县", "长顺县", "龙里县", "惠水县", "三都水族自治县"],
  },
  "云南省": {
    "昆明市": ["五华区", "盘龙区", "官渡区", "西山区", "东川区", "呈贡区", "晋宁区", "富民县", "宜良县", "石林彝族自治县", "嵩明县", "禄劝彝族苗族自治县", "寻甸回族彝族自治县", "安宁市"],
    "曲靖市": ["麒麟区", "沾益区", "马龙区", "陆良县", "师宗县", "罗平县", "富源县", "会泽县", "宣威市"],
    "玉溪市": ["红塔区", "江川区", "通海县", "华宁县", "易门县", "峨山彝族自治县", "新平彝族傣族自治县", "元江哈尼族彝族傣族自治县", "澄江市"],
    "保山市": ["隆阳区", "施甸县", "龙陵县", "昌宁县", "腾冲市"],
    "昭通市": ["昭阳区", "鲁甸县", "巧家县", "盐津县", "大关县", "永善县", "绥江县", "镇雄县", "彝良县", "威信县", "水富市"],
    "丽江市": ["古城区", "玉龙纳西族自治县", "永胜县", "华坪县", "宁蒗彝族自治县"],
    "普洱市": ["思茅区", "宁洱哈尼族彝族自治县", "墨江哈尼族自治县", "景东彝族自治县", "景谷傣族彝族自治县", "镇沅彝族哈尼族拉祜族自治县", "江城哈尼族彝族自治县", "孟连傣族拉祜族佤族自治县", "澜沧拉祜族自治县", "西盟佤族自治县"],
    "临沧市": ["临翔区", "凤庆县", "云县", "永德县", "镇康县", "双江拉祜族佤族布朗族傣族自治县", "耿马傣族佤族自治县", "沧源佤族自治县"],
    "楚雄彝族自治州": ["楚雄市", "禄丰市", "双柏县", "牟定县", "南华县", "姚安县", "大姚县", "永仁县", "元谋县", "武定县"],
    "红河哈尼族彝族自治州": ["个旧市", "开远市", "蒙自市", "弥勒市", "屏边苗族自治县", "建水县", "石屏县", "泸西县", "元阳县", "红河县", "金平苗族瑶族傣族自治县", "绿春县", "河口瑶族自治县"],
    "文山壮族苗族自治州": ["文山市", "砚山县", "西畴县", "麻栗坡县", "马关县", "丘北县", "广南县", "富宁县"],
    "西双版纳傣族自治州": ["景洪市", "勐海县", "勐腊县"],
    "大理白族自治州": ["大理市", "漾濞彝族自治县", "祥云县", "宾川县", "弥渡县", "南涧彝族自治县", "巍山彝族回族自治县", "永平县", "云龙县", "洱源县", "剑川县", "鹤庆县"],
    "德宏傣族景颇族自治州": ["瑞丽市", "芒市", "梁河县", "盈江县", "陇川县"],
    "怒江傈僳族自治州": ["泸水市", "福贡县", "贡山独龙族怒族自治县", "兰坪白族普米族自治县"],
    "迪庆藏族自治州": ["香格里拉市", "德钦县", "维西傈僳族自治县"],
  },
  "西藏自治区": {
    "拉萨市": ["城关区", "堆龙德庆区", "达孜区", "林周县", "当雄县", "尼木县", "曲水县", "墨竹工卡县"],
    "日喀则市": ["桑珠孜区", "南木林县", "江孜县", "定日县", "萨迦县", "拉孜县", "昂仁县", "谢通门县", "白朗县", "仁布县", "康马县", "定结县", "仲巴县", "亚东县", "吉隆县", "聂拉木县", "萨嘎县", "岗巴县"],
    "昌都市": ["卡若区", "江达县", "贡觉县", "类乌齐县", "丁青县", "察雅县", "八宿县", "左贡县", "芒康县", "洛隆县", "边坝县"],
    "林芝市": ["巴宜区", "工布江达县", "墨脱县", "波密县", "察隅县", "朗县", "米林市"],
    "山南市": ["乃东区", "扎囊县", "贡嘎县", "桑日县", "琼结县", "曲松县", "措美县", "洛扎县", "加查县", "隆子县", "浪卡子县", "错那市"],
    "那曲市": ["色尼区", "嘉黎县", "比如县", "聂荣县", "安多县", "申扎县", "索县", "班戈县", "巴青县", "尼玛县", "双湖县"],
    "阿里地区": ["普兰县", "札达县", "噶尔县", "日土县", "革吉县", "改则县", "措勤县"],
  },
  "陕西省": {
    "西安市": ["新城区", "碑林区", "莲湖区", "灞桥区", "未央区", "雁塔区", "阎良区", "临潼区", "长安区", "高陵区", "鄠邑区", "蓝田县", "周至县"],
    "铜川市": ["王益区", "印台区", "耀州区", "宜君县"],
    "宝鸡市": ["渭滨区", "金台区", "陈仓区", "凤翔区", "岐山县", "扶风县", "眉县", "陇县", "千阳县", "麟游县", "凤县", "太白县"],
    "咸阳市": ["秦都区", "杨陵区", "渭城区", "三原县", "泾阳县", "乾县", "礼泉县", "永寿县", "长武县", "旬邑县", "淳化县", "武功县", "兴平市", "彬州市"],
    "渭南市": ["临渭区", "华州区", "潼关县", "大荔县", "合阳县", "澄城县", "蒲城县", "白水县", "富平县", "韩城市", "华阴市"],
    "延安市": ["宝塔区", "安塞区", "延长县", "延川县", "志丹县", "吴起县", "甘泉县", "富县", "洛川县", "宜川县", "黄龙县", "黄陵县", "子长市"],
    "汉中市": ["汉台区", "南郑区", "城固县", "洋县", "西乡县", "勉县", "宁强县", "略阳县", "镇巴县", "留坝县", "佛坪县"],
    "榆林市": ["榆阳区", "横山区", "府谷县", "靖边县", "定边县", "绥德县", "米脂县", "佳县", "吴堡县", "清涧县", "子洲县", "神木市"],
    "安康市": ["汉滨区", "汉阴县", "石泉县", "宁陕县", "紫阳县", "岚皋县", "平利县", "镇坪县", "白河县", "旬阳市"],
    "商洛市": ["商州区", "洛南县", "丹凤县", "商南县", "山阳县", "镇安县", "柞水县"],
  },
  "甘肃省": {
    "兰州市": ["城关区", "七里河区", "西固区", "安宁区", "红古区", "永登县", "皋兰县", "榆中县"],
    "嘉峪关市": ["雄关区", "长城区", "镜铁区"],
    "金昌市": ["金川区", "永昌县"],
    "白银市": ["白银区", "平川区", "靖远县", "会宁县", "景泰县"],
    "天水市": ["秦州区", "麦积区", "清水县", "秦安县", "甘谷县", "武山县", "张家川回族自治县"],
    "武威市": ["凉州区", "民勤县", "古浪县", "天祝藏族自治县"],
    "张掖市": ["甘州区", "肃南裕固族自治县", "民乐县", "临泽县", "高台县", "山丹县"],
    "平凉市": ["崆峒区", "泾川县", "灵台县", "崇信县", "庄浪县", "静宁县", "华亭市"],
    "酒泉市": ["肃州区", "金塔县", "瓜州县", "肃北蒙古族自治县", "阿克塞哈萨克族自治县", "玉门市", "敦煌市"],
    "庆阳市": ["西峰区", "庆城县", "环县", "华池县", "合水县", "正宁县", "宁县", "镇原县"],
    "定西市": ["安定区", "通渭县", "陇西县", "渭源县", "临洮县", "漳县", "岷县"],
    "陇南市": ["武都区", "成县", "文县", "宕昌县", "康县", "西和县", "礼县", "徽县", "两当县"],
    "临夏回族自治州": ["临夏市", "临夏县", "康乐县", "永靖县", "广河县", "和政县", "东乡族自治县", "积石山保安族东乡族撒拉族自治县"],
    "甘南藏族自治州": ["合作市", "临潭县", "卓尼县", "舟曲县", "迭部县", "玛曲县", "碌曲县", "夏河县"],
  },
  "青海省": {
    "西宁市": ["城东区", "城中区", "城西区", "城北区", "湟中区", "大通回族土族自治县", "湟源县"],
    "海东市": ["乐都区", "平安区", "民和回族土族自治县", "互助土族自治县", "化隆回族自治县", "循化撒拉族自治县"],
    "海北藏族自治州": ["门源回族自治县", "祁连县", "海晏县", "刚察县"],
    "黄南藏族自治州": ["同仁市", "尖扎县", "泽库县", "河南蒙古族自治县"],
    "海南藏族自治州": ["共和县", "同德县", "贵德县", "兴海县", "贵南县"],
    "果洛藏族自治州": ["玛沁县", "班玛县", "甘德县", "达日县", "久治县", "玛多县"],
    "玉树藏族自治州": ["玉树市", "杂多县", "称多县", "治多县", "囊谦县", "曲麻莱县"],
    "海西蒙古族藏族自治州": ["格尔木市", "德令哈市", "茫崖市", "乌兰县", "都兰县", "天峻县"],
  },
  "宁夏回族自治区": {
    "银川市": ["兴庆区", "西夏区", "金凤区", "永宁县", "贺兰县", "灵武市"],
    "石嘴山市": ["大武口区", "惠农区", "平罗县"],
    "吴忠市": ["利通区", "红寺堡区", "盐池县", "同心县", "青铜峡市"],
    "固原市": ["原州区", "西吉县", "隆德县", "泾源县", "彭阳县"],
    "中卫市": ["沙坡头区", "中宁县", "海原县"],
  },
  "新疆维吾尔自治区": {
    "乌鲁木齐市": ["天山区", "沙依巴克区", "新市区", "水磨沟区", "头屯河区", "达坂城区", "米东区", "乌鲁木齐县"],
    "克拉玛依市": ["独山子区", "克拉玛依区", "白碱滩区", "乌尔禾区"],
    "吐鲁番市": ["高昌区", "鄯善县", "托克逊县"],
    "哈密市": ["伊州区", "巴里坤哈萨克自治县", "伊吾县"],
    "昌吉回族自治州": ["昌吉市", "阜康市", "呼图壁县", "玛纳斯县", "奇台县", "吉木萨尔县", "木垒哈萨克自治县"],
    "博尔塔拉蒙古自治州": ["博乐市", "阿拉山口市", "精河县", "温泉县"],
    "巴音郭楞蒙古自治州": ["库尔勒市", "轮台县", "尉犁县", "若羌县", "且末县", "焉耆回族自治县", "和静县", "和硕县", "博湖县"],
    "阿克苏地区": ["阿克苏市", "库车市", "温宿县", "沙雅县", "新和县", "拜城县", "乌什县", "阿瓦提县", "柯坪县"],
    "克孜勒苏柯尔克孜自治州": ["阿图什市", "阿克陶县", "阿合奇县", "乌恰县"],
    "喀什地区": ["喀什市", "疏附县", "疏勒县", "英吉沙县", "泽普县", "莎车县", "叶城县", "麦盖提县", "岳普湖县", "伽师县", "巴楚县", "塔什库尔干塔吉克自治县"],
    "和田地区": ["和田市", "和田县", "墨玉县", "皮山县", "洛浦县", "策勒县", "于田县", "民丰县", "和康县", "和安县"],
    "伊犁哈萨克自治州": ["伊宁市", "奎屯市", "霍尔果斯市", "伊宁县", "察布查尔锡伯自治县", "霍城县", "巩留县", "新源县", "昭苏县", "特克斯县", "尼勒克县"],
    "塔城地区": ["塔城市", "乌苏市", "沙湾市", "额敏县", "托里县", "裕民县", "和布克赛尔蒙古自治县"],
    "阿勒泰地区": ["阿勒泰市", "布尔津县", "富蕴县", "福海县", "哈巴河县", "青河县", "吉木乃县"],
    "自治区直辖县级行政区划": ["石河子市", "阿拉尔市", "图木舒克市", "五家渠市", "北屯市", "铁门关市", "双河市", "可克达拉市", "昆玉市", "胡杨河市", "新星市", "白杨市"],
  },
  "香港特别行政区": {
    "香港岛": ["中西区", "湾仔区", "东区", "南区"],
    "九龙": ["油尖旺区", "深水埗区", "九龙城区", "黄大仙区", "观塘区"],
    "新界": ["荃湾区", "屯门区", "元朗区", "北区", "大埔区", "西贡区", "沙田区", "葵青区", "离岛区"],
  },
  "澳门特别行政区": {
    "澳门半岛": ["花地玛堂区", "花王堂区", "望德堂区", "大堂区", "风顺堂区"],
    "氹仔岛": ["嘉模堂区"],
    "路环岛": ["圣方济各堂区"],
    "路凼区": ["路凼填海区"],
  },
  "台湾": {
    "台北市": ["松山区", "信义区", "大安区", "中山区", "中正区", "大同区", "万华区", "文山区", "南港区", "内湖区", "士林区", "北投区"],
    "高雄市": ["盐埕区", "鼓山区", "左营区", "楠梓区", "三民区", "新兴区", "前金区", "苓雅区", "前镇区", "旗津区", "小港区", "凤山区", "林园区", "大寮区", "大树区", "大社区", "仁武区", "鸟松区", "冈山区", "桥头区", "燕巢区", "田寮区", "阿莲区", "路竹区", "湖内区", "茄萣区", "永安区", "弥陀区", "梓官区", "旗山区", "美浓区", "六龟区", "甲仙区", "杉林区", "内门区", "茂林区", "桃源区", "那玛夏区"],
    "基隆市": ["中正区", "七堵区", "暖暖区", "仁爱区", "中山区", "安乐区", "信义区"],
    "台中市": ["中区", "东区", "南区", "西区", "北区", "西屯区", "南屯区", "北屯区", "丰原区", "东势区", "大甲区", "清水区", "沙鹿区", "梧栖区", "后里区", "神冈区", "潭子区", "大雅区", "新社区", "石冈区", "外埔区", "大安区", "乌日区", "大肚区", "龙井区", "雾峰区", "太平区", "大里区", "和平区"],
    "台南市": ["新营区", "盐水区", "白河区", "柳营区", "后壁区", "东山区", "麻豆区", "下营区", "六甲区", "官田区", "大内区", "佳里区", "学甲区", "西港区", "七股区", "将军区", "北门区", "新化区", "善化区", "新市区", "安定区", "山上区", "玉井区", "楠西区", "南化区", "左镇区", "仁德区", "归仁区", "关庙区", "龙崎区", "永康区", "东区", "南区", "北区", "安南区", "安平区", "中西区"],
    "新竹市": ["东区", "北区", "香山区"],
    "嘉义市": ["东区", "西区"],
    "新北市": ["板桥区", "三重区", "中和区", "永和区", "新庄区", "新店区", "树林区", "莺歌区", "三峡区", "淡水区", "汐止区", "瑞芳区", "土城区", "芦洲区", "五股区", "泰山区", "林口区", "深坑区", "石碇区", "坪林区", "三芝区", "石门区", "八里区", "平溪区", "双溪区", "贡寮区", "金山区", "万里区", "乌来区"],
    "桃园市": ["桃园区", "中坜区", "大溪区", "杨梅区", "芦竹区", "大园区", "龟山区", "八德区", "龙潭区", "平镇区", "新屋区", "观音区", "复兴区"],
    "宜兰县": ["宜兰市", "罗东镇", "苏澳镇", "头城镇", "礁溪乡", "壮围乡", "员山乡", "冬山乡", "五结乡", "三星乡", "大同乡", "南澳乡"],
    "连江县": ["南竿乡", "北竿乡", "莒光乡", "东引乡"],
    "金门县": ["金城镇", "金沙镇", "金湖镇", "金宁乡", "烈屿乡", "乌丘乡"],
    "新竹县": ["竹北市", "竹东镇", "新埔镇", "关西镇", "湖口乡", "新丰乡", "芎林乡", "横山乡", "北埔乡", "宝山乡", "峨眉乡", "尖石乡", "五峰乡"],
    "苗栗县": ["苗栗市", "苑里镇", "通霄镇", "竹南镇", "头份市", "后龙镇", "卓兰镇", "大湖乡", "公館乡", "铜锣乡", "南庄乡", "头屋乡", "三义乡", "西湖乡", "造桥乡", "三湾乡", "狮潭乡", "泰安乡"],
    "彰化县": ["彰化市", "鹿港镇", "和美镇", "线西乡", "伸港乡", "福兴乡", "秀水乡", "花坛乡", "芬园乡", "员林市", "溪湖镇", "田中镇", "大村乡", "埔盐乡", "埔心乡", "永靖乡", "社头乡", "二水乡", "北斗镇", "二林镇", "田尾乡", "埤头乡", "芳苑乡", "大城乡", "竹塘乡", "溪州乡"],
    "南投县": ["南投市", "埔里镇", "草屯镇", "竹山镇", "集集镇", "名间乡", "鹿谷乡", "中寮乡", "鱼池乡", "国姓乡", "水里乡", "信义乡", "仁爱乡"],
    "云林县": ["斗六市", "斗南镇", "虎尾镇", "西螺镇", "土库镇", "北港镇", "古坑乡", "大埤乡", "莿桐乡", "林内乡", "二仑乡", "仑背乡", "麦寮乡", "东势乡", "褒忠乡", "台西乡", "元长乡", "四湖乡", "口湖乡", "水林乡"],
    "嘉义县": ["太保市", "朴子市", "布袋镇", "大林镇", "民雄乡", "溪口乡", "新港乡", "六脚乡", "东石乡", "义竹乡", "鹿草乡", "水上乡", "中埔乡", "竹崎乡", "梅山乡", "番路乡", "大埔乡", "阿里山乡"],
    "屏东县": ["屏东市", "潮州镇", "东港镇", "恒春镇", "万丹乡", "长治乡", "麟洛乡", "九如乡", "里港乡", "盐埔乡", "高树乡", "万峦乡", "内埔乡", "竹田乡", "新埤乡", "枋寮乡", "新园乡", "崁顶乡", "林边乡", "南州乡", "佳冬乡", "琉球乡", "车城乡", "满州乡", "枋山乡", "三地门乡", "雾台乡", "玛家乡", "泰武乡", "来义乡", "春日乡", "狮子乡", "牡丹乡"],
    "台东县": ["台东市", "成功镇", "关山镇", "卑南乡", "鹿野乡", "池上乡", "东河乡", "长滨乡", "太麻里乡", "大武乡", "绿岛乡", "海端乡", "延平乡", "金峰乡", "达仁乡", "兰屿乡"],
    "花莲县": ["花莲市", "凤林镇", "玉里镇", "新城乡", "吉安乡", "寿丰乡", "光复乡", "丰滨乡", "瑞穗乡", "富里乡", "秀林乡", "万荣乡", "卓溪乡"],
    "澎湖县": ["马公市", "湖西乡", "白沙乡", "西屿乡", "望安乡", "七美乡"],
  },
};

export const OVERSEAS_AREA_ZH: Record<string, Record<string, string[]>> = {
  "亚洲": {
    "新加坡 (GMT+8)": ["新加坡"],
    "马来西亚 (GMT+8)": ["吉隆坡", "槟城", "新山", "古晋", "马六甲", "亚庇", "怡保", "兰卡威"],
    "韩国 (GMT+9)": ["首尔", "釜山", "仁川", "大邱", "光州", "大田", "济州", "水原"],
    "泰国 (GMT+7)": ["曼谷", "清迈", "普吉", "芭提雅", "清莱", "华欣", "苏梅岛", "甲米"],
    "日本 (GMT+9)": ["东京", "大阪", "京都", "横滨", "名古屋", "福冈", "札幌", "神户", "奈良", "冲绳", "广岛", "仙台"],
    "印度尼西亚 (GMT+7)": ["雅加达", "巴厘岛", "泗水", "棉兰", "万隆", "日惹", "龙目岛", "望加锡"],
    "越南 (GMT+7)": ["河内", "胡志明市", "岘港", "芽庄", "会安", "顺化", "大叻", "富国岛"],
    "菲律宾 (GMT+8)": ["马尼拉", "宿务", "达沃", "碧瑶", "长滩岛", "巴拉望", "克拉克"],
    "印度 (GMT+5:30)": ["孟买", "新德里", "班加罗尔", "钦奈", "加尔各答", "海得拉巴", "浦那", "斋浦尔", "艾哈迈达巴德", "果阿"],
    "阿联酋 (GMT+4)": ["迪拜", "阿布扎比", "沙迦", "阿治曼", "拉斯海玛"],
    "以色列 (GMT+2)": ["特拉维夫", "耶路撒冷", "海法", "埃拉特"],
    "土耳其 (GMT+3)": ["伊斯坦布尔", "安卡拉", "伊兹密尔", "安塔利亚", "卡帕多奇亚", "布尔萨"],
    "柬埔寨 (GMT+7)": ["金边", "暹粒", "西哈努克"],
    "老挝 (GMT+7)": ["万象", "琅勃拉邦", "巴色"],
    "缅甸 (GMT+6:30)": ["仰光", "内比都", "曼德勒", "蒲甘"],
    "尼泊尔 (GMT+5:45)": ["加德满都", "博卡拉", "帕坦"],
    "斯里兰卡 (GMT+5:30)": ["科伦坡", "康提", "加勒"],
    "马尔代夫 (GMT+5)": ["马累"],
    "沙特阿拉伯 (GMT+3)": ["利雅得", "吉达", "麦加", "麦地那", "达曼"],
    "卡塔尔 (GMT+3)": ["多哈"],
    "科威特 (GMT+3)": ["科威特城"],
    "巴林 (GMT+3)": ["麦纳麦"],
    "阿曼 (GMT+4)": ["马斯喀特", "塞拉莱"],
    "约旦 (GMT+3)": ["安曼", "亚喀巴", "佩特拉"],
    "哈萨克斯坦 (GMT+5)": ["阿斯塔纳", "阿拉木图", "奇姆肯特"],
    "乌兹别克斯坦 (GMT+5)": ["塔什干", "撒马尔罕", "布哈拉"],
  },
  "欧洲": {
    "英国 (GMT+0)": ["伦敦", "曼彻斯特", "伯明翰", "利物浦", "爱丁堡", "格拉斯哥", "牛津", "剑桥", "布里斯托", "约克"],
    "法国 (GMT+1)": ["巴黎", "里昂", "马赛", "尼斯", "波尔多", "图卢兹", "斯特拉斯堡", "戛纳", "蒙彼利埃"],
    "德国 (GMT+1)": ["柏林", "慕尼黑", "汉堡", "法兰克福", "科隆", "杜塞尔多夫", "斯图加特", "德累斯顿", "海德堡"],
    "意大利 (GMT+1)": ["罗马", "米兰", "威尼斯", "佛罗伦萨", "那不勒斯", "都灵", "博洛尼亚", "维罗纳", "比萨"],
    "西班牙 (GMT+1)": ["马德里", "巴塞罗那", "塞维利亚", "瓦伦西亚", "马拉加", "格拉纳达", "毕尔巴鄂", "马略卡"],
    "荷兰 (GMT+1)": ["阿姆斯特丹", "鹿特丹", "海牙", "乌得勒支", "埃因霍温"],
    "瑞士 (GMT+1)": ["苏黎世", "日内瓦", "伯尔尼", "巴塞尔", "卢塞恩", "洛桑", "因特拉肯"],
    "俄罗斯 (GMT+3)": ["莫斯科", "圣彼得堡", "新西伯利亚", "叶卡捷琳堡", "喀山", "索契", "符拉迪沃斯托克"],
    "葡萄牙 (GMT+0)": ["里斯本", "波尔图", "法鲁", "科英布拉", "马德拉"],
    "希腊 (GMT+2)": ["雅典", "塞萨洛尼基", "圣托里尼", "米科诺斯", "克里特"],
    "瑞典 (GMT+1)": ["斯德哥尔摩", "哥德堡", "马尔默", "乌普萨拉"],
    "挪威 (GMT+1)": ["奥斯陆", "卑尔根", "特隆赫姆", "特罗姆瑟"],
    "奥地利 (GMT+1)": ["维也纳", "萨尔茨堡", "因斯布鲁克", "格拉茨"],
    "比利时 (GMT+1)": ["布鲁塞尔", "安特卫普", "布鲁日", "根特"],
    "丹麦 (GMT+1)": ["哥本哈根", "奥胡斯", "欧登塞"],
    "芬兰 (GMT+2)": ["赫尔辛基", "坦佩雷", "图尔库", "罗瓦涅米"],
    "爱尔兰 (GMT+0)": ["都柏林", "科克", "戈尔韦"],
    "捷克 (GMT+1)": ["布拉格", "布尔诺", "卡罗维发利"],
    "波兰 (GMT+1)": ["华沙", "克拉科夫", "格但斯克", "弗罗茨瓦夫"],
    "匈牙利 (GMT+1)": ["布达佩斯", "德布勒森"],
    "克罗地亚 (GMT+1)": ["萨格勒布", "杜布罗夫尼克", "斯普利特"],
    "冰岛 (GMT+0)": ["雷克雅未克", "阿克雷里"],
    "卢森堡 (GMT+1)": ["卢森堡市"],
  },
  "北美洲": {
    "美国 (GMT-5)": ["纽约", "洛杉矶", "芝加哥", "休斯顿", "旧金山", "西雅图", "波士顿", "迈阿密", "拉斯维加斯", "华盛顿", "奥兰多", "达拉斯", "亚特兰大", "费城", "圣地亚哥", "丹佛", "夏威夷檀香山"],
    "加拿大 (GMT-5)": ["多伦多", "温哥华", "蒙特利尔", "卡尔加里", "渥太华", "魁北克城", "埃德蒙顿", "温尼伯"],
    "墨西哥 (GMT-6)": ["墨西哥城", "瓜达拉哈拉", "蒙特雷", "坎昆", "蒂华纳", "梅里达"],
    "古巴 (GMT-5)": ["哈瓦那", "巴拉德罗"],
    "巴拿马 (GMT-5)": ["巴拿马城"],
    "哥斯达黎加 (GMT-6)": ["圣何塞"],
    "多米尼加 (GMT-4)": ["圣多明各", "蓬塔卡纳"],
  },
  "南美洲": {
    "阿根廷 (GMT-3)": ["布宜诺斯艾利斯", "科尔多瓦", "罗萨里奥", "门多萨"],
    "智利 (GMT-4)": ["圣地亚哥", "瓦尔帕莱索", "蓬塔阿雷纳斯"],
    "哥伦比亚 (GMT-5)": ["波哥大", "麦德林", "卡利", "卡塔赫纳"],
    "秘鲁 (GMT-5)": ["利马", "库斯科", "阿雷基帕"],
    "巴西 (GMT-3)": ["圣保罗", "里约热内卢", "巴西利亚", "萨尔瓦多", "福塔莱萨", "累西腓", "库里蒂巴"],
    "厄瓜多尔 (GMT-5)": ["基多", "瓜亚基尔"],
    "乌拉圭 (GMT-3)": ["蒙得维的亚", "埃斯特角城"],
    "委内瑞拉 (GMT-4)": ["加拉加斯", "马拉开波"],
  },
  "大洋洲": {
    "新西兰 (GMT+12)": ["奥克兰", "惠灵顿", "基督城", "皇后镇", "罗托鲁瓦", "但尼丁"],
    "斐济 (GMT+12)": ["苏瓦", "楠迪"],
    "澳大利亚 (GMT+10)": ["悉尼", "墨尔本", "布里斯班", "珀斯", "阿德莱德", "堪培拉", "黄金海岸", "凯恩斯", "达尔文", "霍巴特"],
    "巴布亚新几内亚 (GMT+10)": ["莫尔兹比港"],
    "法属波利尼西亚 (GMT-10)": ["帕皮提"],
  },
  "非洲": {
    "南非 (GMT+2)": ["约翰内斯堡", "开普敦", "德班", "比勒陀利亚", "伊丽莎白港"],
    "埃及 (GMT+2)": ["开罗", "亚历山大", "卢克索", "阿斯旺", "沙姆沙伊赫", "赫尔格达"],
    "摩洛哥 (GMT+1)": ["卡萨布兰卡", "马拉喀什", "拉巴特", "非斯", "丹吉尔"],
    "肯尼亚 (GMT+3)": ["内罗毕", "蒙巴萨"],
    "尼日利亚 (GMT+1)": ["拉各斯", "阿布贾", "卡诺"],
    "坦桑尼亚 (GMT+3)": ["达累斯萨拉姆", "阿鲁沙", "桑给巴尔"],
    "毛里求斯 (GMT+4)": ["路易港"],
    "塞舌尔 (GMT+4)": ["维多利亚"],
    "突尼斯 (GMT+1)": ["突尼斯市", "苏塞"],
    "阿尔及利亚 (GMT+1)": ["阿尔及尔", "奥兰"],
    "埃塞俄比亚 (GMT+3)": ["亚的斯亚贝巴"],
    "加纳 (GMT+0)": ["阿克拉", "库马西"],
  },
};

export const OVERSEAS_AREA_EN: Record<string, Record<string, string[]>> = {
  "亚洲": {
    "新加坡 (GMT+8)": ["Singapore"],
    "马来西亚 (GMT+8)": ["Kuala Lumpur", "Penang", "Johor Bahru", "Kuching", "Malacca", "Kota Kinabalu", "Ipoh", "Langkawi"],
    "韩国 (GMT+9)": ["Seoul", "Busan", "Incheon", "Daegu", "Gwangju", "Daejeon", "Jeju", "Suwon"],
    "泰国 (GMT+7)": ["Bangkok", "Chiang Mai", "Phuket", "Pattaya", "Chiang Rai", "Hua Hin", "Koh Samui", "Krabi"],
    "日本 (GMT+9)": ["Tokyo", "Osaka", "Kyoto", "Yokohama", "Nagoya", "Fukuoka", "Sapporo", "Kobe", "Nara", "Okinawa", "Hiroshima", "Sendai"],
    "印度尼西亚 (GMT+7)": ["Jakarta", "Bali", "Surabaya", "Medan", "Bandung", "Yogyakarta", "Lombok", "Makassar"],
    "越南 (GMT+7)": ["Hanoi", "Ho Chi Minh City", "Da Nang", "Nha Trang", "Hoi An", "Hue", "Da Lat", "Phu Quoc"],
    "菲律宾 (GMT+8)": ["Manila", "Cebu", "Davao", "Baguio", "Boracay", "Palawan", "Clark"],
    "印度 (GMT+5:30)": ["Mumbai", "New Delhi", "Bangalore", "Chennai", "Kolkata", "Hyderabad", "Pune", "Jaipur", "Ahmedabad", "Goa"],
    "阿联酋 (GMT+4)": ["Dubai", "Abu Dhabi", "Sharjah", "Ajman", "Ras Al Khaimah"],
    "以色列 (GMT+2)": ["Tel Aviv", "Jerusalem", "Haifa", "Eilat"],
    "土耳其 (GMT+3)": ["Istanbul", "Ankara", "Izmir", "Antalya", "Cappadocia", "Bursa"],
    "柬埔寨 (GMT+7)": ["Phnom Penh", "Siem Reap", "Sihanoukville"],
    "老挝 (GMT+7)": ["Vientiane", "Luang Prabang", "Pakse"],
    "缅甸 (GMT+6:30)": ["Yangon", "Naypyidaw", "Mandalay", "Bagan"],
    "尼泊尔 (GMT+5:45)": ["Kathmandu", "Pokhara", "Patan"],
    "斯里兰卡 (GMT+5:30)": ["Colombo", "Kandy", "Galle"],
    "马尔代夫 (GMT+5)": ["Male"],
    "沙特阿拉伯 (GMT+3)": ["Riyadh", "Jeddah", "Mecca", "Medina", "Dammam"],
    "卡塔尔 (GMT+3)": ["Doha"],
    "科威特 (GMT+3)": ["Kuwait City"],
    "巴林 (GMT+3)": ["Manama"],
    "阿曼 (GMT+4)": ["Muscat", "Salalah"],
    "约旦 (GMT+3)": ["Amman", "Aqaba", "Petra"],
    "哈萨克斯坦 (GMT+5)": ["Astana", "Almaty", "Shymkent"],
    "乌兹别克斯坦 (GMT+5)": ["Tashkent", "Samarkand", "Bukhara"],
  },
  "欧洲": {
    "英国 (GMT+0)": ["London", "Manchester", "Birmingham", "Liverpool", "Edinburgh", "Glasgow", "Oxford", "Cambridge", "Bristol", "York"],
    "法国 (GMT+1)": ["Paris", "Lyon", "Marseille", "Nice", "Bordeaux", "Toulouse", "Strasbourg", "Cannes", "Montpellier"],
    "德国 (GMT+1)": ["Berlin", "Munich", "Hamburg", "Frankfurt", "Cologne", "Dusseldorf", "Stuttgart", "Dresden", "Heidelberg"],
    "意大利 (GMT+1)": ["Rome", "Milan", "Venice", "Florence", "Naples", "Turin", "Bologna", "Verona", "Pisa"],
    "西班牙 (GMT+1)": ["Madrid", "Barcelona", "Seville", "Valencia", "Malaga", "Granada", "Bilbao", "Mallorca"],
    "荷兰 (GMT+1)": ["Amsterdam", "Rotterdam", "The Hague", "Utrecht", "Eindhoven"],
    "瑞士 (GMT+1)": ["Zurich", "Geneva", "Bern", "Basel", "Lucerne", "Lausanne", "Interlaken"],
    "俄罗斯 (GMT+3)": ["Moscow", "Saint Petersburg", "Novosibirsk", "Yekaterinburg", "Kazan", "Sochi", "Vladivostok"],
    "葡萄牙 (GMT+0)": ["Lisbon", "Porto", "Faro", "Coimbra", "Madeira"],
    "希腊 (GMT+2)": ["Athens", "Thessaloniki", "Santorini", "Mykonos", "Crete"],
    "瑞典 (GMT+1)": ["Stockholm", "Gothenburg", "Malmo", "Uppsala"],
    "挪威 (GMT+1)": ["Oslo", "Bergen", "Trondheim", "Tromso"],
    "奥地利 (GMT+1)": ["Vienna", "Salzburg", "Innsbruck", "Graz"],
    "比利时 (GMT+1)": ["Brussels", "Antwerp", "Bruges", "Ghent"],
    "丹麦 (GMT+1)": ["Copenhagen", "Aarhus", "Odense"],
    "芬兰 (GMT+2)": ["Helsinki", "Tampere", "Turku", "Rovaniemi"],
    "爱尔兰 (GMT+0)": ["Dublin", "Cork", "Galway"],
    "捷克 (GMT+1)": ["Prague", "Brno", "Karlovy Vary"],
    "波兰 (GMT+1)": ["Warsaw", "Krakow", "Gdansk", "Wroclaw"],
    "匈牙利 (GMT+1)": ["Budapest", "Debrecen"],
    "克罗地亚 (GMT+1)": ["Zagreb", "Dubrovnik", "Split"],
    "冰岛 (GMT+0)": ["Reykjavik", "Akureyri"],
    "卢森堡 (GMT+1)": ["Luxembourg City"],
  },
  "北美洲": {
    "美国 (GMT-5)": ["New York", "Los Angeles", "Chicago", "Houston", "San Francisco", "Seattle", "Boston", "Miami", "Las Vegas", "Washington D.C.", "Orlando", "Dallas", "Atlanta", "Philadelphia", "San Diego", "Denver", "Honolulu"],
    "加拿大 (GMT-5)": ["Toronto", "Vancouver", "Montreal", "Calgary", "Ottawa", "Quebec City", "Edmonton", "Winnipeg"],
    "墨西哥 (GMT-6)": ["Mexico City", "Guadalajara", "Monterrey", "Cancun", "Tijuana", "Merida"],
    "古巴 (GMT-5)": ["Havana", "Varadero"],
    "巴拿马 (GMT-5)": ["Panama City"],
    "哥斯达黎加 (GMT-6)": ["San Jose"],
    "多米尼加 (GMT-4)": ["Santo Domingo", "Punta Cana"],
  },
  "南美洲": {
    "阿根廷 (GMT-3)": ["Buenos Aires", "Cordoba", "Rosario", "Mendoza"],
    "智利 (GMT-4)": ["Santiago", "Valparaiso", "Punta Arenas"],
    "哥伦比亚 (GMT-5)": ["Bogota", "Medellin", "Cali", "Cartagena"],
    "秘鲁 (GMT-5)": ["Lima", "Cusco", "Arequipa"],
    "巴西 (GMT-3)": ["Sao Paulo", "Rio de Janeiro", "Brasilia", "Salvador", "Fortaleza", "Recife", "Curitiba"],
    "厄瓜多尔 (GMT-5)": ["Quito", "Guayaquil"],
    "乌拉圭 (GMT-3)": ["Montevideo", "Punta del Este"],
    "委内瑞拉 (GMT-4)": ["Caracas", "Maracaibo"],
  },
  "大洋洲": {
    "新西兰 (GMT+12)": ["Auckland", "Wellington", "Christchurch", "Queenstown", "Rotorua", "Dunedin"],
    "斐济 (GMT+12)": ["Suva", "Nadi"],
    "澳大利亚 (GMT+10)": ["Sydney", "Melbourne", "Brisbane", "Perth", "Adelaide", "Canberra", "Gold Coast", "Cairns", "Darwin", "Hobart"],
    "巴布亚新几内亚 (GMT+10)": ["Port Moresby"],
    "法属波利尼西亚 (GMT-10)": ["Papeete"],
  },
  "非洲": {
    "南非 (GMT+2)": ["Johannesburg", "Cape Town", "Durban", "Pretoria", "Port Elizabeth"],
    "埃及 (GMT+2)": ["Cairo", "Alexandria", "Luxor", "Aswan", "Sharm El Sheikh", "Hurghada"],
    "摩洛哥 (GMT+1)": ["Casablanca", "Marrakech", "Rabat", "Fez", "Tangier"],
    "肯尼亚 (GMT+3)": ["Nairobi", "Mombasa"],
    "尼日利亚 (GMT+1)": ["Lagos", "Abuja", "Kano"],
    "坦桑尼亚 (GMT+3)": ["Dar es Salaam", "Arusha", "Zanzibar"],
    "毛里求斯 (GMT+4)": ["Port Louis"],
    "塞舌尔 (GMT+4)": ["Victoria"],
    "突尼斯 (GMT+1)": ["Tunis", "Sousse"],
    "阿尔及利亚 (GMT+1)": ["Algiers", "Oran"],
    "埃塞俄比亚 (GMT+3)": ["Addis Ababa"],
    "加纳 (GMT+0)": ["Accra", "Kumasi"],
  },
};

export const CITY_COORDS: Record<string, { lat: number; lng: number; tz: number }> = {
  "北京市": { lat: 39.928359, lng: 116.416334, tz: 8 },
  "天津市": { lat: 39.116884, lng: 117.214713, tz: 8 },
  "石家庄市": { lat: 38.03682, lng: 114.538955, tz: 8 },
  "唐山市": { lat: 39.624988, lng: 118.154348, tz: 8 },
  "秦皇岛市": { lat: 39.94756, lng: 119.564962, tz: 8 },
  "邯郸市": { lat: 36.59457, lng: 114.531062, tz: 8 },
  "邢台市": { lat: 37.071314, lng: 114.507443, tz: 8 },
  "保定市": { lat: 38.877318, lng: 115.458671, tz: 8 },
  "张家口市": { lat: 40.788472, lng: 114.894114, tz: 8 },
  "承德市": { lat: 40.974679, lng: 117.943121, tz: 8 },
  "沧州市": { lat: 38.314094, lng: 116.866309, tz: 8 },
  "廊坊市": { lat: 39.502569, lng: 116.694544, tz: 8 },
  "衡水市": { lat: 37.735152, lng: 115.675208, tz: 8 },
  "太原市": { lat: 37.736865, lng: 112.565524, tz: 8 },
  "大同市": { lat: 40.256355, lng: 113.139628, tz: 8 },
  "阳泉市": { lat: 37.847457, lng: 113.600694, tz: 8 },
  "长治市": { lat: 36.203305, lng: 113.122725, tz: 8 },
  "晋城市": { lat: 35.50248, lng: 112.853452, tz: 8 },
  "朔州市": { lat: 39.320196, lng: 112.432071, tz: 8 },
  "晋中市": { lat: 37.698637, lng: 112.707564, tz: 8 },
  "运城市": { lat: 35.015549, lng: 110.998135, tz: 8 },
  "忻州市": { lat: 38.403498, lng: 112.746357, tz: 8 },
  "临汾市": { lat: 36.082463, lng: 111.578797, tz: 8 },
  "吕梁市": { lat: 37.517797, lng: 111.150325, tz: 8 },
  "呼和浩特市": { lat: 40.858271, lng: 111.665325, tz: 8 },
  "包头市": { lat: 40.57626, lng: 110.044008, tz: 8 },
  "乌海市": { lat: 39.690873, lng: 106.8228, tz: 8 },
  "赤峰市": { lat: 42.296317, lng: 118.953989, tz: 8 },
  "通辽市": { lat: 43.623133, lng: 122.25545, tz: 8 },
  "鄂尔多斯市": { lat: 39.823066, lng: 109.963403, tz: 8 },
  "呼伦贝尔市": { lat: 49.234715, lng: 119.824542, tz: 8 },
  "巴彦淖尔市": { lat: 40.750969, lng: 107.363536, tz: 8 },
  "乌兰察布市": { lat: 41.000742, lng: 113.168973, tz: 8 },
  "兴安盟": { lat: 46.072233, lng: 122.093309, tz: 8 },
  "锡林郭勒盟": { lat: 43.64285, lng: 111.949594, tz: 8 },
  "阿拉善盟": { lat: 38.833589, lng: 105.666208, tz: 8 },
  "沈阳市": { lat: 41.789766, lng: 123.420401, tz: 8 },
  "大连市": { lat: 38.918357, lng: 121.644996, tz: 8 },
  "鞍山市": { lat: 41.089578, lng: 122.990888, tz: 8 },
  "抚顺市": { lat: 41.861922, lng: 123.91293, tz: 8 },
  "本溪市": { lat: 41.299658, lng: 123.769081, tz: 8 },
  "丹东市": { lat: 40.136549, lng: 124.395577, tz: 8 },
  "锦州市": { lat: 41.117481, lng: 121.128414, tz: 8 },
  "营口市": { lat: 40.673063, lng: 122.259058, tz: 8 },
  "阜新市": { lat: 42.017794, lng: 121.662594, tz: 8 },
  "辽阳市": { lat: 41.270397, lng: 123.174347, tz: 8 },
  "盘锦市": { lat: 41.212401, lng: 122.07597, tz: 8 },
  "铁岭市": { lat: 42.286575, lng: 123.842472, tz: 8 },
  "朝阳市": { lat: 41.565814, lng: 120.453717, tz: 8 },
  "葫芦岛市": { lat: 40.774784, lng: 120.869157, tz: 8 },
  "金普新区": { lat: 39.0523, lng: 121.785, tz: 8 },
  "长春市": { lat: 43.495116, lng: 124.79379, tz: 8 },
  "吉林市": { lat: 43.881896, lng: 126.574414, tz: 8 },
  "四平市": { lat: 43.146288, lng: 124.345994, tz: 8 },
  "辽源市": { lat: 42.902194, lng: 125.13703, tz: 8 },
  "通化市": { lat: 41.702872, lng: 125.927187, tz: 8 },
  "白山市": { lat: 41.945409, lng: 126.416093, tz: 8 },
  "松原市": { lat: 45.209435, lng: 124.875965, tz: 8 },
  "白城市": { lat: 45.621545, lng: 122.851105, tz: 8 },
  "延边朝鲜族自治州": { lat: 42.891034, lng: 129.507655, tz: 8 },
  "哈尔滨市": { lat: 45.755832, lng: 126.616912, tz: 8 },
  "齐齐哈尔市": { lat: 47.317103, lng: 123.958447, tz: 8 },
  "鸡西市": { lat: 45.303892, lng: 130.981342, tz: 8 },
  "鹤岗市": { lat: 47.342478, lng: 130.294331, tz: 8 },
  "双鸭山市": { lat: 46.646083, lng: 131.158372, tz: 8 },
  "大庆市": { lat: 46.629281, lng: 125.135269, tz: 8 },
  "伊春市": { lat: 47.728257, lng: 128.907156, tz: 8 },
  "佳木斯市": { lat: 46.807808, lng: 130.365263, tz: 8 },
  "七台河市": { lat: 45.816579, lng: 130.93226, tz: 8 },
  "牡丹江市": { lat: 44.58125, lng: 129.626651, tz: 8 },
  "黑河市": { lat: 50.252361, lng: 127.500703, tz: 8 },
  "绥化市": { lat: 46.638114, lng: 126.984995, tz: 8 },
  "大兴安岭地区": { lat: 52.972465, lng: 122.539313, tz: 8 },
  "上海市": { lat: 31.231661, lng: 121.48442, tz: 8 },
  "南京市": { lat: 32.048644, lng: 118.797779, tz: 8 },
  "无锡市": { lat: 31.589484, lng: 120.357732, tz: 8 },
  "徐州市": { lat: 34.288736, lng: 117.185643, tz: 8 },
  "常州市": { lat: 31.79232, lng: 119.999439, tz: 8 },
  "苏州市": { lat: 31.329601, lng: 120.434238, tz: 8 },
  "南通市": { lat: 32.065972, lng: 121.073742, tz: 8 },
  "连云港市": { lat: 34.760317, lng: 119.338901, tz: 8 },
  "淮安市": { lat: 33.531037, lng: 119.167809, tz: 8 },
  "盐城市": { lat: 33.391414, lng: 120.196148, tz: 8 },
  "扬州市": { lat: 32.395654, lng: 119.431785, tz: 8 },
  "镇江市": { lat: 32.198285, lng: 119.470186, tz: 8 },
  "泰州市": { lat: 32.49248, lng: 119.923825, tz: 8 },
  "宿迁市": { lat: 33.963891, lng: 118.242048, tz: 8 },
  "杭州市": { lat: 30.226543, lng: 120.19732, tz: 8 },
  "宁波市": { lat: 29.873705, lng: 121.550485, tz: 8 },
  "温州市": { lat: 28.015776, lng: 120.655199, tz: 8 },
  "嘉兴市": { lat: 30.747738, lng: 120.782952, tz: 8 },
  "湖州市": { lat: 30.857184, lng: 120.185608, tz: 8 },
  "绍兴市": { lat: 29.989092, lng: 120.582338, tz: 8 },
  "金华市": { lat: 29.087311, lng: 119.571574, tz: 8 },
  "衢州市": { lat: 28.936937, lng: 118.874138, tz: 8 },
  "舟山市": { lat: 30.019795, lng: 122.106844, tz: 8 },
  "台州市": { lat: 28.673334, lng: 121.442859, tz: 8 },
  "丽水市": { lat: 28.4461, lng: 119.912266, tz: 8 },
  "舟山群岛新区": { lat: 30.0406, lng: 121.893, tz: 8 },
  "合肥市": { lat: 31.858111, lng: 117.30944, tz: 8 },
  "芜湖市": { lat: 31.34056, lng: 118.385133, tz: 8 },
  "蚌埠市": { lat: 32.90863, lng: 117.454544, tz: 8 },
  "淮南市": { lat: 32.631519, lng: 117.053314, tz: 8 },
  "马鞍山市": { lat: 31.700127, lng: 118.511366, tz: 8 },
  "淮北市": { lat: 33.991412, lng: 116.827949, tz: 8 },
  "铜陵市": { lat: 30.936772, lng: 117.856541, tz: 8 },
  "安庆市": { lat: 30.512768, lng: 117.090878, tz: 8 },
  "黄山市": { lat: 29.69655, lng: 118.315012, tz: 8 },
  "滁州市": { lat: 32.334475, lng: 118.32115, tz: 8 },
  "阜阳市": { lat: 32.883322, lng: 115.806916, tz: 8 },
  "宿州市": { lat: 33.640205, lng: 116.977039, tz: 8 },
  "六安市": { lat: 31.75014, lng: 116.539458, tz: 8 },
  "亳州市": { lat: 33.876436, lng: 115.779081, tz: 8 },
  "池州市": { lat: 30.688237, lng: 117.568087, tz: 8 },
  "宣城市": { lat: 30.944356, lng: 118.786098, tz: 8 },
  "福州市": { lat: 26.082666, lng: 119.304507, tz: 8 },
  "厦门市": { lat: 24.445676, lng: 118.082745, tz: 8 },
  "莆田市": { lat: 25.419062, lng: 118.994261, tz: 8 },
  "三明市": { lat: 26.271653, lng: 117.646153, tz: 8 },
  "泉州市": { lat: 24.908133, lng: 118.58652, tz: 8 },
  "漳州市": { lat: 24.510937, lng: 117.653727, tz: 8 },
  "南平市": { lat: 26.637503, lng: 118.181806, tz: 8 },
  "龙岩市": { lat: 25.098942, lng: 117.036816, tz: 8 },
  "宁德市": { lat: 26.660658, lng: 119.526284, tz: 8 },
  "南昌市": { lat: 28.698787, lng: 115.903576, tz: 8 },
  "景德镇市": { lat: 29.273683, lng: 117.182648, tz: 8 },
  "萍乡市": { lat: 27.615, lng: 113.87072, tz: 8 },
  "九江市": { lat: 29.668008, lng: 115.992735, tz: 8 },
  "新余市": { lat: 27.799526, lng: 114.944499, tz: 8 },
  "鹰潭市": { lat: 28.266999, lng: 117.10247, tz: 8 },
  "赣州市": { lat: 25.818247, lng: 114.920426, tz: 8 },
  "吉安市": { lat: 27.144204, lng: 114.994991, tz: 8 },
  "宜春市": { lat: 27.796344, lng: 114.42794, tz: 8 },
  "抚州市": { lat: 27.935098, lng: 116.311932, tz: 8 },
  "上饶市": { lat: 28.430694, lng: 117.965997, tz: 8 },
  "济南市": { lat: 36.666395, lng: 117.07632, tz: 8 },
  "青岛市": { lat: 36.075867, lng: 120.412002, tz: 8 },
  "淄博市": { lat: 36.644211, lng: 117.966978, tz: 8 },
  "枣庄市": { lat: 34.863791, lng: 117.556125, tz: 8 },
  "东营市": { lat: 37.449035, lng: 118.582182, tz: 8 },
  "烟台市": { lat: 37.541312, lng: 121.400303, tz: 8 },
  "潍坊市": { lat: 36.728077, lng: 119.02491, tz: 8 },
  "济宁市": { lat: 35.444226, lng: 116.605763, tz: 8 },
  "泰安市": { lat: 36.194963, lng: 117.128828, tz: 8 },
  "威海市": { lat: 37.501735, lng: 122.123115, tz: 8 },
  "日照市": { lat: 35.426037, lng: 119.462287, tz: 8 },
  "临沂市": { lat: 35.052797, lng: 118.347332, tz: 8 },
  "德州市": { lat: 37.451051, lng: 116.299558, tz: 8 },
  "聊城市": { lat: 36.412737, lng: 116.006399, tz: 8 },
  "滨州市": { lat: 37.431997, lng: 118.019567, tz: 8 },
  "菏泽市": { lat: 35.251911, lng: 115.417021, tz: 8 },
  "郑州市": { lat: 34.74828, lng: 113.612966, tz: 8 },
  "开封市": { lat: 34.815515, lng: 114.355378, tz: 8 },
  "洛阳市": { lat: 34.683645, lng: 112.469071, tz: 8 },
  "平顶山市": { lat: 33.736486, lng: 113.296956, tz: 8 },
  "安阳市": { lat: 36.090593, lng: 114.356967, tz: 8 },
  "鹤壁市": { lat: 35.954647, lng: 114.163133, tz: 8 },
  "新乡市": { lat: 35.306182, lng: 113.983358, tz: 8 },
  "焦作市": { lat: 35.240403, lng: 113.230555, tz: 8 },
  "濮阳市": { lat: 35.778289, lng: 115.074453, tz: 8 },
  "许昌市": { lat: 34.047189, lng: 113.830826, tz: 8 },
  "漯河市": { lat: 33.572319, lng: 113.984164, tz: 8 },
  "三门峡市": { lat: 34.771296, lng: 111.188552, tz: 8 },
  "南阳市": { lat: 33.003564, lng: 112.539506, tz: 8 },
  "商丘市": { lat: 34.444519, lng: 115.613609, tz: 8 },
  "信阳市": { lat: 32.116885, lng: 114.05867, tz: 8 },
  "周口市": { lat: 33.647679, lng: 114.650551, tz: 8 },
  "驻马店市": { lat: 32.97455, lng: 113.993753, tz: 8 },
  "省直辖县级行政区划": { lat: 35.069057, lng: 112.602347, tz: 8 },
  "武汉市": { lat: 30.633093, lng: 114.282987, tz: 8 },
  "黄石市": { lat: 30.223194, lng: 115.065653, tz: 8 },
  "十堰市": { lat: 32.591847, lng: 110.813478, tz: 8 },
  "宜昌市": { lat: 30.710765, lng: 111.285696, tz: 8 },
  "襄阳市": { lat: 32.009932, lng: 112.134025, tz: 8 },
  "鄂州市": { lat: 30.100146, lng: 114.684805, tz: 8 },
  "荆门市": { lat: 31.05187, lng: 112.201657, tz: 8 },
  "孝感市": { lat: 30.91695, lng: 113.910769, tz: 8 },
  "荆州市": { lat: 30.326693, lng: 112.251975, tz: 8 },
  "黄冈市": { lat: 30.434354, lng: 114.880104, tz: 8 },
  "咸宁市": { lat: 29.852726, lng: 114.299002, tz: 8 },
  "随州市": { lat: 31.716423, lng: 113.371052, tz: 8 },
  "恩施土家族苗族自治州": { lat: 30.295148, lng: 109.479572, tz: 8 },
  "直辖市县": { lat: 18.774827, lng: 109.516784, tz: 8 },
  "长沙市": { lat: 28.185351, lng: 113.032605, tz: 8 },
  "株洲市": { lat: 27.856314, lng: 113.173169, tz: 8 },
  "湘潭市": { lat: 27.856115, lng: 112.907334, tz: 8 },
  "衡阳市": { lat: 26.894796, lng: 112.620653, tz: 8 },
  "邵阳市": { lat: 27.232286, lng: 111.496946, tz: 8 },
  "岳阳市": { lat: 29.371356, lng: 113.129362, tz: 8 },
  "常德市": { lat: 29.055332, lng: 111.683043, tz: 8 },
  "张家界市": { lat: 29.119662, lng: 110.537379, tz: 8 },
  "益阳市": { lat: 28.59149, lng: 112.324286, tz: 8 },
  "郴州市": { lat: 25.784632, lng: 113.010606, tz: 8 },
  "永州市": { lat: 26.222278, lng: 111.629806, tz: 8 },
  "怀化市": { lat: 27.578581, lng: 110.040099, tz: 8 },
  "娄底市": { lat: 27.730208, lng: 112.001922, tz: 8 },
  "湘西土家族苗族自治州": { lat: 28.261948, lng: 109.698348, tz: 8 },
  "广州市": { lat: 23.107123, lng: 113.218998, tz: 8 },
  "韶关市": { lat: 24.7929, lng: 113.58792, tz: 8 },
  "深圳市": { lat: 22.548309, lng: 114.131611, tz: 8 },
  "珠海市": { lat: 22.265635, lng: 113.543372, tz: 8 },
  "汕头市": { lat: 23.372211, lng: 116.716464, tz: 8 },
  "佛山市": { lat: 23.009475, lng: 113.122532, tz: 8 },
  "江门市": { lat: 22.595285, lng: 113.078914, tz: 8 },
  "湛江市": { lat: 21.265948, lng: 110.365592, tz: 8 },
  "茂名市": { lat: 21.641661, lng: 110.918566, tz: 8 },
  "肇庆市": { lat: 23.051847, lng: 112.485577, tz: 8 },
  "惠州市": { lat: 23.084657, lng: 114.382526, tz: 8 },
  "梅州市": { lat: 24.31065, lng: 116.116686, tz: 8 },
  "汕尾市": { lat: 22.779204, lng: 115.36522, tz: 8 },
  "河源市": { lat: 23.734055, lng: 114.703305, tz: 8 },
  "阳江市": { lat: 21.862451, lng: 111.95486, tz: 8 },
  "清远市": { lat: 23.697889, lng: 113.062612, tz: 8 },
  "东莞市": { lat: 23.0418, lng: 113.7518, tz: 8 },
  "中山市": { lat: 22.52522, lng: 113.378835, tz: 8 },
  "潮州市": { lat: 23.675104, lng: 116.628343, tz: 8 },
  "揭阳市": { lat: 23.525918, lng: 116.36714, tz: 8 },
  "云浮市": { lat: 22.92815, lng: 112.043945, tz: 8 },
  "南宁市": { lat: 22.85354, lng: 108.368071, tz: 8 },
  "柳州市": { lat: 24.366964, lng: 109.427398, tz: 8 },
  "桂林市": { lat: 25.273954, lng: 110.264102, tz: 8 },
  "梧州市": { lat: 23.470543, lng: 111.318065, tz: 8 },
  "北海市": { lat: 21.474914, lng: 109.117256, tz: 8 },
  "防城港市": { lat: 21.643426, lng: 108.380273, tz: 8 },
  "钦州市": { lat: 21.940438, lng: 108.657427, tz: 8 },
  "贵港市": { lat: 23.11136, lng: 109.572227, tz: 8 },
  "玉林市": { lat: 22.628476, lng: 110.150717, tz: 8 },
  "百色市": { lat: 23.900804, lng: 106.618151, tz: 8 },
  "贺州市": { lat: 24.411822, lng: 111.552029, tz: 8 },
  "河池市": { lat: 24.692865, lng: 108.085166, tz: 8 },
  "来宾市": { lat: 23.727647, lng: 109.183284, tz: 8 },
  "崇左市": { lat: 22.40609, lng: 107.353694, tz: 8 },
  "海口市": { lat: 20.007703, lng: 110.293566, tz: 8 },
  "三亚市": { lat: 18.384177, lng: 109.735676, tz: 8 },
  "三沙市": { lat: 16.834372, lng: 112.346961, tz: 8 },
  "重庆市": { lat: 30.807621, lng: 108.408591, tz: 8 },
  "成都市": { lat: 30.598726, lng: 104.117262, tz: 8 },
  "自贡市": { lat: 29.337295, lng: 104.777182, tz: 8 },
  "攀枝花市": { lat: 26.546484, lng: 101.704129, tz: 8 },
  "泸州市": { lat: 28.87881, lng: 105.434982, tz: 8 },
  "德阳市": { lat: 31.143335, lng: 104.417061, tz: 8 },
  "绵阳市": { lat: 31.455192, lng: 104.756917, tz: 8 },
  "广元市": { lat: 32.433756, lng: 105.845307, tz: 8 },
  "遂宁市": { lat: 30.526201, lng: 105.568359, tz: 8 },
  "内江市": { lat: 29.587091, lng: 105.06759, tz: 8 },
  "乐山市": { lat: 29.555374, lng: 103.761329, tz: 8 },
  "南充市": { lat: 30.797366, lng: 106.092327, tz: 8 },
  "眉山市": { lat: 30.041956, lng: 103.831868, tz: 8 },
  "宜宾市": { lat: 28.766537, lng: 104.619853, tz: 8 },
  "广安市": { lat: 30.473943, lng: 106.641628, tz: 8 },
  "达州市": { lat: 31.214665, lng: 107.505053, tz: 8 },
  "雅安市": { lat: 30.005718, lng: 103.032868, tz: 8 },
  "巴中市": { lat: 31.851458, lng: 106.76887, tz: 8 },
  "资阳市": { lat: 30.107778, lng: 104.676814, tz: 8 },
  "阿坝藏族羌族自治州": { lat: 31.905799, lng: 102.206386, tz: 8 },
  "甘孜藏族自治州": { lat: 29.998544, lng: 101.95687, tz: 8 },
  "凉山彝族自治州": { lat: 27.89441, lng: 102.264166, tz: 8 },
  "贵阳市": { lat: 26.568055, lng: 106.714305, tz: 8 },
  "六盘水市": { lat: 26.574699, lng: 104.843723, tz: 8 },
  "遵义市": { lat: 27.644793, lng: 106.893598, tz: 8 },
  "安顺市": { lat: 26.243928, lng: 105.966086, tz: 8 },
  "毕节市": { lat: 27.298304, lng: 105.305219, tz: 8 },
  "铜仁市": { lat: 27.815244, lng: 109.264271, tz: 8 },
  "黔西南布依族苗族自治州": { lat: 25.09196, lng: 104.895503, tz: 8 },
  "黔东南苗族侗族自治州": { lat: 26.5662, lng: 107.981409, tz: 8 },
  "黔南布依族苗族自治州": { lat: 26.259456, lng: 107.518628, tz: 8 },
  "昆明市": { lat: 25.043635, lng: 102.707262, tz: 8 },
  "曲靖市": { lat: 25.496472, lng: 103.804406, tz: 8 },
  "玉溪市": { lat: 24.341215, lng: 102.540122, tz: 8 },
  "保山市": { lat: 25.121137, lng: 99.165638, tz: 8 },
  "昭通市": { lat: 27.320035, lng: 103.706323, tz: 8 },
  "丽江市": { lat: 26.876468, lng: 100.22583, tz: 8 },
  "普洱市": { lat: 22.786769, lng: 100.977069, tz: 8 },
  "临沧市": { lat: 23.895298, lng: 100.082073, tz: 8 },
  "楚雄彝族自治州": { lat: 25.032945, lng: 101.546242, tz: 8 },
  "红河哈尼族彝族自治州": { lat: 23.389935, lng: 103.152663, tz: 8 },
  "文山壮族苗族自治州": { lat: 23.38683, lng: 104.233237, tz: 8 },
  "西双版纳傣族自治州": { lat: 22.011792, lng: 100.799595, tz: 8 },
  "大理白族自治州": { lat: 25.678466, lng: 100.301614, tz: 8 },
  "德宏傣族景颇族自治州": { lat: 24.018377, lng: 97.855423, tz: 8 },
  "怒江傈僳族自治州": { lat: 25.822579, lng: 98.857723, tz: 8 },
  "迪庆藏族自治州": { lat: 27.842185, lng: 99.743582, tz: 8 },
  "拉萨市": { lat: 29.654813, lng: 91.140368, tz: 8 },
  "日喀则市": { lat: 29.247726, lng: 88.898503, tz: 8 },
  "昌都市": { lat: 31.112087, lng: 97.196021, tz: 8 },
  "林芝市": { lat: 29.636576, lng: 94.361094, tz: 8 },
  "山南市": { lat: 29.224904, lng: 91.761538, tz: 8 },
  "那曲市": { lat: 31.469645, lng: 92.053498, tz: 8 },
  "阿里地区": { lat: 30.290467, lng: 81.177116, tz: 8 },
  "西安市": { lat: 34.266601, lng: 108.960707, tz: 8 },
  "铜川市": { lat: 35.068925, lng: 109.075615, tz: 8 },
  "宝鸡市": { lat: 34.355068, lng: 107.155344, tz: 8 },
  "咸阳市": { lat: 34.329478, lng: 108.706347, tz: 8 },
  "渭南市": { lat: 34.498902, lng: 109.510051, tz: 8 },
  "延安市": { lat: 36.585138, lng: 109.489726, tz: 8 },
  "汉中市": { lat: 33.067523, lng: 107.03201, tz: 8 },
  "榆林市": { lat: 38.277078, lng: 109.72054, tz: 8 },
  "安康市": { lat: 32.695436, lng: 109.026928, tz: 8 },
  "商洛市": { lat: 33.862979, lng: 109.941452, tz: 8 },
  "兰州市": { lat: 36.056948, lng: 103.825315, tz: 8 },
  "嘉峪关市": { lat: 39.7793, lng: 98.2774, tz: 8 },
  "金昌市": { lat: 38.520373, lng: 102.1939, tz: 8 },
  "白银市": { lat: 36.53469, lng: 104.14956, tz: 8 },
  "天水市": { lat: 34.581187, lng: 105.724914, tz: 8 },
  "武威市": { lat: 37.928217, lng: 102.641959, tz: 8 },
  "张掖市": { lat: 38.944315, lng: 100.415324, tz: 8 },
  "平凉市": { lat: 35.542437, lng: 106.67489, tz: 8 },
  "酒泉市": { lat: 39.74511, lng: 98.507834, tz: 8 },
  "庆阳市": { lat: 35.730318, lng: 107.650563, tz: 8 },
  "定西市": { lat: 35.580918, lng: 104.610647, tz: 8 },
  "陇南市": { lat: 33.400685, lng: 104.921861, tz: 8 },
  "临夏回族自治州": { lat: 35.604682, lng: 103.24222, tz: 8 },
  "甘南藏族自治州": { lat: 35.000228, lng: 102.910305, tz: 8 },
  "西宁市": { lat: 36.599744, lng: 101.803717, tz: 8 },
  "海东市": { lat: 36.482242, lng: 102.401614, tz: 8 },
  "海北藏族自治州": { lat: 37.388567, lng: 101.611524, tz: 8 },
  "黄南藏族自治州": { lat: 35.515769, lng: 102.018663, tz: 8 },
  "海南藏族自治州": { lat: 36.284158, lng: 100.619405, tz: 8 },
  "果洛藏族自治州": { lat: 34.478049, lng: 100.238873, tz: 8 },
  "玉树藏族自治州": { lat: 32.992934, lng: 97.009184, tz: 8 },
  "海西蒙古族藏族自治州": { lat: 36.407272, lng: 94.928293, tz: 8 },
  "银川市": { lat: 38.473972, lng: 106.288452, tz: 8 },
  "石嘴山市": { lat: 39.018409, lng: 106.379323, tz: 8 },
  "吴忠市": { lat: 38.00298, lng: 106.235842, tz: 8 },
  "固原市": { lat: 36.003777, lng: 106.28784, tz: 8 },
  "中卫市": { lat: 37.516859, lng: 105.173875, tz: 8 },
  "乌鲁木齐市": { lat: 43.794312, lng: 87.631986, tz: 8 },
  "克拉玛依市": { lat: 44.328096, lng: 84.886973, tz: 8 },
  "吐鲁番市": { lat: 42.942728, lng: 89.185891, tz: 8 },
  "哈密市": { lat: 42.835492, lng: 93.425934, tz: 8 },
  "昌吉回族自治州": { lat: 44.014468, lng: 87.267432, tz: 8 },
  "博尔塔拉蒙古自治州": { lat: 44.853882, lng: 82.051433, tz: 8 },
  "巴音郭楞蒙古自治州": { lat: 41.725891, lng: 86.174633, tz: 8 },
  "阿克苏地区": { lat: 41.16755, lng: 80.263387, tz: 8 },
  "克孜勒苏柯尔克孜自治州": { lat: 39.667719, lng: 76.084541, tz: 8 },
  "喀什地区": { lat: 39.46823, lng: 75.993936, tz: 8 },
  "和田地区": { lat: 37.112246, lng: 79.912881, tz: 8 },
  "伊犁哈萨克自治州": { lat: 43.908021, lng: 81.277715, tz: 8 },
  "塔城地区": { lat: 46.751669, lng: 82.986923, tz: 8 },
  "阿勒泰地区": { lat: 47.827308, lng: 88.131842, tz: 8 },
  "自治区直辖县级行政区划": { lat: 44.305368, lng: 86.080397, tz: 8 },
  "香港岛": { lat: 22.282, lng: 114.154, tz: 8 },
  "九龙": { lat: 22.321, lng: 114.172, tz: 8 },
  "新界": { lat: 22.371, lng: 114.114, tz: 8 },
  "澳门半岛": { lat: 22.211, lng: 113.552, tz: 8 },
  "氹仔岛": { lat: 22.156, lng: 113.558, tz: 8 },
  "路环岛": { lat: 22.124, lng: 113.559, tz: 8 },
  "路凼区": { lat: 22.142, lng: 113.567, tz: 8 },
  "台北市": { lat: 25.0503, lng: 121.5775, tz: 8 },
  "高雄市": { lat: 22.6261, lng: 120.2839, tz: 8 },
  "基隆市": { lat: 25.1089, lng: 121.7433, tz: 8 },
  "台中市": { lat: 24.1447, lng: 120.68, tz: 8 },
  "台南市": { lat: 23.3019, lng: 120.3117, tz: 8 },
  "新竹市": { lat: 24.8136, lng: 120.98, tz: 8 },
  "嘉义市": { lat: 23.4842, lng: 120.4611, tz: 8 },
  "新北市": { lat: 25.0128, lng: 121.4622, tz: 8 },
  "桃园市": { lat: 24.9936, lng: 121.3009, tz: 8 },
  "宜兰县": { lat: 24.753419195332643, lng: 121.75654103711254, tz: 8 },
  "连江县": { lat: 26.157581164227913, lng: 119.93667103997899, tz: 8 },
  "金门县": { lat: 24.413106936344317, lng: 118.31291288366532, tz: 8 },
  "新竹县": { lat: 24.834230370024887, lng: 121.0047688879713, tz: 8 },
  "苗栗县": { lat: 24.55824959039901, lng: 120.80377148621362, tz: 8 },
  "彰化县": { lat: 24.072032781594523, lng: 120.56188796666534, tz: 8 },
  "南投县": { lat: 23.923002988224525, lng: 120.67571688140995, tz: 8 },
  "云林县": { lat: 23.700012661208262, lng: 120.57144603712074, tz: 8 },
  "嘉义县": { lat: 23.47689876962328, lng: 120.35413455894032, tz: 8 },
  "屏东县": { lat: 22.666078261170018, lng: 120.48741492856321, tz: 8 },
  "台东县": { lat: 22.76217683937383, lng: 121.11288914106446, tz: 8 },
  "花莲县": { lat: 23.99855657583641, lng: 121.60066767863124, tz: 8 },
  "澎湖县": { lat: 23.542424211335618, lng: 119.57573544240138, tz: 8 },
  "新加坡": { lat: 1.28967, lng: 103.85007, tz: 8 },
  "Singapore": { lat: 1.28967, lng: 103.85007, tz: 8 },
  "吉隆坡": { lat: 3.1412, lng: 101.68653, tz: 8 },
  "Kuala Lumpur": { lat: 3.1412, lng: 101.68653, tz: 8 },
  "槟城": { lat: 5.3991, lng: 100.36382, tz: 8 },
  "Penang": { lat: 5.3991, lng: 100.36382, tz: 8 },
  "新山": { lat: 1.4655, lng: 103.7578, tz: 8 },
  "Johor Bahru": { lat: 1.4655, lng: 103.7578, tz: 8 },
  "古晋": { lat: 1.5533, lng: 110.3592, tz: 8 },
  "Kuching": { lat: 1.5533, lng: 110.3592, tz: 8 },
  "马六甲": { lat: 2.196, lng: 102.2405, tz: 8 },
  "Malacca": { lat: 2.196, lng: 102.2405, tz: 8 },
  "亚庇": { lat: 5.9804, lng: 116.0735, tz: 8 },
  "Kota Kinabalu": { lat: 5.9804, lng: 116.0735, tz: 8 },
  "怡保": { lat: 4.5841, lng: 101.0829, tz: 8 },
  "Ipoh": { lat: 4.5841, lng: 101.0829, tz: 8 },
  "兰卡威": { lat: 6.35, lng: 99.8, tz: 8 },
  "Langkawi": { lat: 6.35, lng: 99.8, tz: 8 },
  "首尔": { lat: 37.566, lng: 126.9784, tz: 9 },
  "Seoul": { lat: 37.566, lng: 126.9784, tz: 9 },
  "釜山": { lat: 35.10168, lng: 129.03004, tz: 9 },
  "Busan": { lat: 35.10168, lng: 129.03004, tz: 9 },
  "仁川": { lat: 37.45646, lng: 126.70515, tz: 9 },
  "Incheon": { lat: 37.45646, lng: 126.70515, tz: 9 },
  "大邱": { lat: 35.87028, lng: 128.59111, tz: 9 },
  "Daegu": { lat: 35.87028, lng: 128.59111, tz: 9 },
  "光州": { lat: 35.15472, lng: 126.91556, tz: 9 },
  "Gwangju": { lat: 35.15472, lng: 126.91556, tz: 9 },
  "大田": { lat: 36.34913, lng: 127.38493, tz: 9 },
  "Daejeon": { lat: 36.34913, lng: 127.38493, tz: 9 },
  "济州": { lat: 33.4996, lng: 126.5312, tz: 9 },
  "Jeju": { lat: 33.4996, lng: 126.5312, tz: 9 },
  "水原": { lat: 37.29111, lng: 127.00889, tz: 9 },
  "Suwon": { lat: 37.29111, lng: 127.00889, tz: 9 },
  "曼谷": { lat: 13.75398, lng: 100.50144, tz: 7 },
  "Bangkok": { lat: 13.75398, lng: 100.50144, tz: 7 },
  "清迈": { lat: 18.79038, lng: 98.98468, tz: 7 },
  "Chiang Mai": { lat: 18.79038, lng: 98.98468, tz: 7 },
  "普吉": { lat: 7.89059, lng: 98.3981, tz: 7 },
  "Phuket": { lat: 7.89059, lng: 98.3981, tz: 7 },
  "芭提雅": { lat: 12.9236, lng: 100.8825, tz: 7 },
  "Pattaya": { lat: 12.9236, lng: 100.8825, tz: 7 },
  "清莱": { lat: 19.9105, lng: 99.8406, tz: 7 },
  "Chiang Rai": { lat: 19.9105, lng: 99.8406, tz: 7 },
  "华欣": { lat: 12.5684, lng: 99.9577, tz: 7 },
  "Hua Hin": { lat: 12.5684, lng: 99.9577, tz: 7 },
  "苏梅岛": { lat: 9.512, lng: 100.0136, tz: 7 },
  "Koh Samui": { lat: 9.512, lng: 100.0136, tz: 7 },
  "甲米": { lat: 8.07257, lng: 98.91052, tz: 7 },
  "Krabi": { lat: 8.07257, lng: 98.91052, tz: 7 },
  "东京": { lat: 35.6895, lng: 139.69171, tz: 9 },
  "Tokyo": { lat: 35.6895, lng: 139.69171, tz: 9 },
  "大阪": { lat: 34.69379, lng: 135.50107, tz: 9 },
  "Osaka": { lat: 34.69379, lng: 135.50107, tz: 9 },
  "京都": { lat: 35.02107, lng: 135.75385, tz: 9 },
  "Kyoto": { lat: 35.02107, lng: 135.75385, tz: 9 },
  "横滨": { lat: 35.43333, lng: 139.65, tz: 9 },
  "Yokohama": { lat: 35.43333, lng: 139.65, tz: 9 },
  "名古屋": { lat: 35.18147, lng: 136.90641, tz: 9 },
  "Nagoya": { lat: 35.18147, lng: 136.90641, tz: 9 },
  "福冈": { lat: 33.5902, lng: 130.4017, tz: 9 },
  "Fukuoka": { lat: 33.5902, lng: 130.4017, tz: 9 },
  "札幌": { lat: 43.06667, lng: 141.35, tz: 9 },
  "Sapporo": { lat: 43.06667, lng: 141.35, tz: 9 },
  "神户": { lat: 34.6913, lng: 135.183, tz: 9 },
  "Kobe": { lat: 34.6913, lng: 135.183, tz: 9 },
  "奈良": { lat: 34.68505, lng: 135.80485, tz: 9 },
  "Nara": { lat: 34.68505, lng: 135.80485, tz: 9 },
  "冲绳": { lat: 26.2124, lng: 127.6809, tz: 9 },
  "Okinawa": { lat: 26.2124, lng: 127.6809, tz: 9 },
  "广岛": { lat: 34.3853, lng: 132.4553, tz: 9 },
  "Hiroshima": { lat: 34.3853, lng: 132.4553, tz: 9 },
  "仙台": { lat: 38.26667, lng: 140.86667, tz: 9 },
  "Sendai": { lat: 38.26667, lng: 140.86667, tz: 9 },
  "雅加达": { lat: -6.21462, lng: 106.84513, tz: 7 },
  "Jakarta": { lat: -6.21462, lng: 106.84513, tz: 7 },
  "巴厘岛": { lat: -8.3405, lng: 115.092, tz: 8 },
  "Bali": { lat: -8.3405, lng: 115.092, tz: 8 },
  "泗水": { lat: -7.24917, lng: 112.75083, tz: 7 },
  "Surabaya": { lat: -7.24917, lng: 112.75083, tz: 7 },
  "棉兰": { lat: 3.5952, lng: 98.6722, tz: 7 },
  "Medan": { lat: 3.5952, lng: 98.6722, tz: 7 },
  "万隆": { lat: -6.92222, lng: 107.60694, tz: 7 },
  "Bandung": { lat: -6.92222, lng: 107.60694, tz: 7 },
  "日惹": { lat: -7.80139, lng: 110.36472, tz: 7 },
  "Yogyakarta": { lat: -7.80139, lng: 110.36472, tz: 7 },
  "龙目岛": { lat: -8.65, lng: 116.3249, tz: 8 },
  "Lombok": { lat: -8.65, lng: 116.3249, tz: 8 },
  "望加锡": { lat: -5.1477, lng: 119.4327, tz: 8 },
  "Makassar": { lat: -5.1477, lng: 119.4327, tz: 8 },
  "河内": { lat: 21.0278, lng: 105.8342, tz: 7 },
  "Hanoi": { lat: 21.0278, lng: 105.8342, tz: 7 },
  "胡志明市": { lat: 10.82302, lng: 106.62965, tz: 7 },
  "Ho Chi Minh City": { lat: 10.82302, lng: 106.62965, tz: 7 },
  "岘港": { lat: 16.06778, lng: 108.22083, tz: 7 },
  "Da Nang": { lat: 16.06778, lng: 108.22083, tz: 7 },
  "芽庄": { lat: 12.24507, lng: 109.19432, tz: 7 },
  "Nha Trang": { lat: 12.24507, lng: 109.19432, tz: 7 },
  "会安": { lat: 15.8801, lng: 108.338, tz: 7 },
  "Hoi An": { lat: 15.8801, lng: 108.338, tz: 7 },
  "顺化": { lat: 16.4619, lng: 107.59546, tz: 7 },
  "Hue": { lat: 16.4619, lng: 107.59546, tz: 7 },
  "大叻": { lat: 11.9404, lng: 108.4583, tz: 7 },
  "Da Lat": { lat: 11.9404, lng: 108.4583, tz: 7 },
  "富国岛": { lat: 10.2899, lng: 103.984, tz: 7 },
  "Phu Quoc": { lat: 10.2899, lng: 103.984, tz: 7 },
  "马尼拉": { lat: 14.6042, lng: 120.9822, tz: 8 },
  "Manila": { lat: 14.6042, lng: 120.9822, tz: 8 },
  "宿务": { lat: 10.3157, lng: 123.8854, tz: 8 },
  "Cebu": { lat: 10.3157, lng: 123.8854, tz: 8 },
  "达沃": { lat: 7.07306, lng: 125.61278, tz: 8 },
  "Davao": { lat: 7.07306, lng: 125.61278, tz: 8 },
  "碧瑶": { lat: 16.41639, lng: 120.59306, tz: 8 },
  "Baguio": { lat: 16.41639, lng: 120.59306, tz: 8 },
  "长滩岛": { lat: 11.9674, lng: 121.9248, tz: 8 },
  "Boracay": { lat: 11.9674, lng: 121.9248, tz: 8 },
  "巴拉望": { lat: 9.8349, lng: 118.7384, tz: 8 },
  "Palawan": { lat: 9.8349, lng: 118.7384, tz: 8 },
  "克拉克": { lat: 15.185, lng: 120.5397, tz: 8 },
  "Clark": { lat: 15.185, lng: 120.5397, tz: 8 },
  "孟买": { lat: 19.07283, lng: 72.88261, tz: 5.5 },
  "Mumbai": { lat: 19.07283, lng: 72.88261, tz: 5.5 },
  "新德里": { lat: 28.62137, lng: 77.2148, tz: 5.5 },
  "New Delhi": { lat: 28.62137, lng: 77.2148, tz: 5.5 },
  "班加罗尔": { lat: 12.97194, lng: 77.59369, tz: 5.5 },
  "Bangalore": { lat: 12.97194, lng: 77.59369, tz: 5.5 },
  "钦奈": { lat: 13.0827, lng: 80.2707, tz: 5.5 },
  "Chennai": { lat: 13.0827, lng: 80.2707, tz: 5.5 },
  "加尔各答": { lat: 22.56263, lng: 88.36304, tz: 5.5 },
  "Kolkata": { lat: 22.56263, lng: 88.36304, tz: 5.5 },
  "海得拉巴": { lat: 17.38405, lng: 78.45636, tz: 5.5 },
  "Hyderabad": { lat: 17.38405, lng: 78.45636, tz: 5.5 },
  "浦那": { lat: 18.51957, lng: 73.85535, tz: 5.5 },
  "Pune": { lat: 18.51957, lng: 73.85535, tz: 5.5 },
  "斋浦尔": { lat: 26.9124, lng: 75.7873, tz: 5.5 },
  "Jaipur": { lat: 26.9124, lng: 75.7873, tz: 5.5 },
  "艾哈迈达巴德": { lat: 23.02579, lng: 72.58727, tz: 5.5 },
  "Ahmedabad": { lat: 23.02579, lng: 72.58727, tz: 5.5 },
  "果阿": { lat: 15.2993, lng: 74.124, tz: 5.5 },
  "Goa": { lat: 15.2993, lng: 74.124, tz: 5.5 },
  "迪拜": { lat: 25.07725, lng: 55.30927, tz: 4 },
  "Dubai": { lat: 25.07725, lng: 55.30927, tz: 4 },
  "阿布扎比": { lat: 24.45118, lng: 54.39696, tz: 4 },
  "Abu Dhabi": { lat: 24.45118, lng: 54.39696, tz: 4 },
  "沙迦": { lat: 25.3463, lng: 55.4209, tz: 4 },
  "Sharjah": { lat: 25.3463, lng: 55.4209, tz: 4 },
  "阿治曼": { lat: 25.4052, lng: 55.5136, tz: 4 },
  "Ajman": { lat: 25.4052, lng: 55.5136, tz: 4 },
  "拉斯海玛": { lat: 25.8007, lng: 55.9762, tz: 4 },
  "Ras Al Khaimah": { lat: 25.8007, lng: 55.9762, tz: 4 },
  "特拉维夫": { lat: 32.08088, lng: 34.78057, tz: 2 },
  "Tel Aviv": { lat: 32.08088, lng: 34.78057, tz: 2 },
  "耶路撒冷": { lat: 31.76904, lng: 35.21633, tz: 2 },
  "Jerusalem": { lat: 31.76904, lng: 35.21633, tz: 2 },
  "海法": { lat: 32.81303, lng: 34.99928, tz: 2 },
  "Haifa": { lat: 32.81303, lng: 34.99928, tz: 2 },
  "埃拉特": { lat: 29.55805, lng: 34.94821, tz: 2 },
  "Eilat": { lat: 29.55805, lng: 34.94821, tz: 2 },
  "伊斯坦布尔": { lat: 41.01384, lng: 28.94966, tz: 3 },
  "Istanbul": { lat: 41.01384, lng: 28.94966, tz: 3 },
  "安卡拉": { lat: 39.91987, lng: 32.85427, tz: 3 },
  "Ankara": { lat: 39.91987, lng: 32.85427, tz: 3 },
  "伊兹密尔": { lat: 38.41273, lng: 27.13838, tz: 3 },
  "Izmir": { lat: 38.41273, lng: 27.13838, tz: 3 },
  "安塔利亚": { lat: 36.90812, lng: 30.69556, tz: 3 },
  "Antalya": { lat: 36.90812, lng: 30.69556, tz: 3 },
  "卡帕多奇亚": { lat: 38.6431, lng: 34.8286, tz: 3 },
  "Cappadocia": { lat: 38.6431, lng: 34.8286, tz: 3 },
  "布尔萨": { lat: 40.19559, lng: 29.06013, tz: 3 },
  "Bursa": { lat: 40.19559, lng: 29.06013, tz: 3 },
  "金边": { lat: 11.56245, lng: 104.91601, tz: 7 },
  "Phnom Penh": { lat: 11.56245, lng: 104.91601, tz: 7 },
  "暹粒": { lat: 13.36179, lng: 103.86056, tz: 7 },
  "Siem Reap": { lat: 13.36179, lng: 103.86056, tz: 7 },
  "西哈努克": { lat: 10.60932, lng: 103.52958, tz: 7 },
  "Sihanoukville": { lat: 10.60932, lng: 103.52958, tz: 7 },
  "万象": { lat: 17.96667, lng: 102.6, tz: 7 },
  "Vientiane": { lat: 17.96667, lng: 102.6, tz: 7 },
  "琅勃拉邦": { lat: 19.8933, lng: 102.1525, tz: 7 },
  "Luang Prabang": { lat: 19.8933, lng: 102.1525, tz: 7 },
  "巴色": { lat: 15.12022, lng: 105.79898, tz: 7 },
  "Pakse": { lat: 15.12022, lng: 105.79898, tz: 7 },
  "仰光": { lat: 16.80528, lng: 96.15611, tz: 6.5 },
  "Yangon": { lat: 16.80528, lng: 96.15611, tz: 6.5 },
  "内比都": { lat: 19.7633, lng: 96.0785, tz: 6.5 },
  "Naypyidaw": { lat: 19.7633, lng: 96.0785, tz: 6.5 },
  "曼德勒": { lat: 21.97473, lng: 96.08359, tz: 6.5 },
  "Mandalay": { lat: 21.97473, lng: 96.08359, tz: 6.5 },
  "蒲甘": { lat: 21.1717, lng: 94.8585, tz: 6.5 },
  "Bagan": { lat: 21.1717, lng: 94.8585, tz: 6.5 },
  "加德满都": { lat: 27.7172, lng: 85.324, tz: 5.75 },
  "Kathmandu": { lat: 27.7172, lng: 85.324, tz: 5.75 },
  "博卡拉": { lat: 28.2096, lng: 83.9856, tz: 5.75 },
  "Pokhara": { lat: 28.2096, lng: 83.9856, tz: 5.75 },
  "帕坦": { lat: 27.6766, lng: 85.3142, tz: 5.75 },
  "Patan": { lat: 27.6766, lng: 85.3142, tz: 5.75 },
  "科伦坡": { lat: 6.9271, lng: 79.8612, tz: 5.5 },
  "Colombo": { lat: 6.9271, lng: 79.8612, tz: 5.5 },
  "康提": { lat: 7.2906, lng: 80.6336, tz: 5.5 },
  "Kandy": { lat: 7.2906, lng: 80.6336, tz: 5.5 },
  "加勒": { lat: 6.0329, lng: 80.2168, tz: 5.5 },
  "Galle": { lat: 6.0329, lng: 80.2168, tz: 5.5 },
  "马累": { lat: 4.1755, lng: 73.5093, tz: 5 },
  "Male": { lat: 4.1755, lng: 73.5093, tz: 5 },
  "利雅得": { lat: 24.68773, lng: 46.72185, tz: 3 },
  "Riyadh": { lat: 24.68773, lng: 46.72185, tz: 3 },
  "吉达": { lat: 21.49012, lng: 39.18624, tz: 3 },
  "Jeddah": { lat: 21.49012, lng: 39.18624, tz: 3 },
  "麦加": { lat: 21.3891, lng: 39.8579, tz: 3 },
  "Mecca": { lat: 21.3891, lng: 39.8579, tz: 3 },
  "麦地那": { lat: 24.46861, lng: 39.61417, tz: 3 },
  "Medina": { lat: 24.46861, lng: 39.61417, tz: 3 },
  "达曼": { lat: 26.43442, lng: 50.10326, tz: 3 },
  "Dammam": { lat: 26.43442, lng: 50.10326, tz: 3 },
  "多哈": { lat: 25.28545, lng: 51.53096, tz: 3 },
  "Doha": { lat: 25.28545, lng: 51.53096, tz: 3 },
  "科威特城": { lat: 29.3759, lng: 47.9774, tz: 3 },
  "Kuwait City": { lat: 29.3759, lng: 47.9774, tz: 3 },
  "麦纳麦": { lat: 26.22787, lng: 50.58565, tz: 3 },
  "Manama": { lat: 26.22787, lng: 50.58565, tz: 3 },
  "马斯喀特": { lat: 23.58413, lng: 58.40778, tz: 4 },
  "Muscat": { lat: 23.58413, lng: 58.40778, tz: 4 },
  "塞拉莱": { lat: 17.0194, lng: 54.1108, tz: 4 },
  "Salalah": { lat: 17.0194, lng: 54.1108, tz: 4 },
  "安曼": { lat: 31.95522, lng: 35.94503, tz: 3 },
  "Amman": { lat: 31.95522, lng: 35.94503, tz: 3 },
  "亚喀巴": { lat: 29.5321, lng: 35.0063, tz: 3 },
  "Aqaba": { lat: 29.5321, lng: 35.0063, tz: 3 },
  "佩特拉": { lat: 30.3285, lng: 35.4444, tz: 3 },
  "Petra": { lat: 30.3285, lng: 35.4444, tz: 3 },
  "阿斯塔纳": { lat: 51.1801, lng: 71.44598, tz: 5 },
  "Astana": { lat: 51.1801, lng: 71.44598, tz: 5 },
  "阿拉木图": { lat: 43.222, lng: 76.8512, tz: 5 },
  "Almaty": { lat: 43.222, lng: 76.8512, tz: 5 },
  "奇姆肯特": { lat: 42.30988, lng: 69.60042, tz: 5 },
  "Shymkent": { lat: 42.30988, lng: 69.60042, tz: 5 },
  "塔什干": { lat: 41.26465, lng: 69.21627, tz: 5 },
  "Tashkent": { lat: 41.26465, lng: 69.21627, tz: 5 },
  "撒马尔罕": { lat: 39.65456, lng: 66.96445, tz: 5 },
  "Samarkand": { lat: 39.65456, lng: 66.96445, tz: 5 },
  "布哈拉": { lat: 39.77026, lng: 64.43069, tz: 5 },
  "Bukhara": { lat: 39.77026, lng: 64.43069, tz: 5 },
  "伦敦": { lat: 51.50853, lng: -0.12574, tz: 0 },
  "London": { lat: 51.50853, lng: -0.12574, tz: 0 },
  "曼彻斯特": { lat: 53.48095, lng: -2.23743, tz: 0 },
  "Manchester": { lat: 53.48095, lng: -2.23743, tz: 0 },
  "伯明翰": { lat: 52.48142, lng: -1.89983, tz: 0 },
  "Birmingham": { lat: 52.48142, lng: -1.89983, tz: 0 },
  "利物浦": { lat: 53.41058, lng: -2.97794, tz: 0 },
  "Liverpool": { lat: 53.41058, lng: -2.97794, tz: 0 },
  "爱丁堡": { lat: 55.95206, lng: -3.19648, tz: 0 },
  "Edinburgh": { lat: 55.95206, lng: -3.19648, tz: 0 },
  "格拉斯哥": { lat: 55.86515, lng: -4.25763, tz: 0 },
  "Glasgow": { lat: 55.86515, lng: -4.25763, tz: 0 },
  "牛津": { lat: 51.75222, lng: -1.25596, tz: 0 },
  "Oxford": { lat: 51.75222, lng: -1.25596, tz: 0 },
  "剑桥": { lat: 52.2053, lng: 0.1218, tz: 0 },
  "Cambridge": { lat: 52.2053, lng: 0.1218, tz: 0 },
  "布里斯托": { lat: 51.45523, lng: -2.59665, tz: 0 },
  "Bristol": { lat: 51.45523, lng: -2.59665, tz: 0 },
  "约克": { lat: 53.959, lng: -1.0815, tz: 0 },
  "York": { lat: 53.959, lng: -1.0815, tz: 0 },
  "巴黎": { lat: 48.85341, lng: 2.3488, tz: 1 },
  "Paris": { lat: 48.85341, lng: 2.3488, tz: 1 },
  "里昂": { lat: 45.74906, lng: 4.84789, tz: 1 },
  "Lyon": { lat: 45.74906, lng: 4.84789, tz: 1 },
  "马赛": { lat: 43.29695, lng: 5.38107, tz: 1 },
  "Marseille": { lat: 43.29695, lng: 5.38107, tz: 1 },
  "尼斯": { lat: 43.70313, lng: 7.26608, tz: 1 },
  "Nice": { lat: 43.70313, lng: 7.26608, tz: 1 },
  "波尔多": { lat: 44.84124, lng: -0.58046, tz: 1 },
  "Bordeaux": { lat: 44.84124, lng: -0.58046, tz: 1 },
  "图卢兹": { lat: 43.6047, lng: 1.4442, tz: 1 },
  "Toulouse": { lat: 43.6047, lng: 1.4442, tz: 1 },
  "斯特拉斯堡": { lat: 48.58392, lng: 7.74553, tz: 1 },
  "Strasbourg": { lat: 48.58392, lng: 7.74553, tz: 1 },
  "戛纳": { lat: 43.55135, lng: 7.01275, tz: 1 },
  "Cannes": { lat: 43.55135, lng: 7.01275, tz: 1 },
  "蒙彼利埃": { lat: 43.61093, lng: 3.87635, tz: 1 },
  "Montpellier": { lat: 43.61093, lng: 3.87635, tz: 1 },
  "柏林": { lat: 52.52437, lng: 13.41053, tz: 1 },
  "Berlin": { lat: 52.52437, lng: 13.41053, tz: 1 },
  "慕尼黑": { lat: 48.13743, lng: 11.57549, tz: 1 },
  "Munich": { lat: 48.13743, lng: 11.57549, tz: 1 },
  "汉堡": { lat: 53.55073, lng: 9.99302, tz: 1 },
  "Hamburg": { lat: 53.55073, lng: 9.99302, tz: 1 },
  "法兰克福": { lat: 50.11552, lng: 8.68417, tz: 1 },
  "Frankfurt": { lat: 50.11552, lng: 8.68417, tz: 1 },
  "科隆": { lat: 50.93333, lng: 6.95, tz: 1 },
  "Cologne": { lat: 50.93333, lng: 6.95, tz: 1 },
  "杜塞尔多夫": { lat: 51.22319, lng: 6.77927, tz: 1 },
  "Dusseldorf": { lat: 51.22319, lng: 6.77927, tz: 1 },
  "斯图加特": { lat: 48.78232, lng: 9.17702, tz: 1 },
  "Stuttgart": { lat: 48.78232, lng: 9.17702, tz: 1 },
  "德累斯顿": { lat: 51.05089, lng: 13.73832, tz: 1 },
  "Dresden": { lat: 51.05089, lng: 13.73832, tz: 1 },
  "海德堡": { lat: 49.40768, lng: 8.69079, tz: 1 },
  "Heidelberg": { lat: 49.40768, lng: 8.69079, tz: 1 },
  "罗马": { lat: 41.89193, lng: 12.51133, tz: 1 },
  "Rome": { lat: 41.89193, lng: 12.51133, tz: 1 },
  "米兰": { lat: 45.4642, lng: 9.19, tz: 1 },
  "Milan": { lat: 45.4642, lng: 9.19, tz: 1 },
  "威尼斯": { lat: 45.43713, lng: 12.33265, tz: 1 },
  "Venice": { lat: 45.43713, lng: 12.33265, tz: 1 },
  "佛罗伦萨": { lat: 43.77925, lng: 11.24626, tz: 1 },
  "Florence": { lat: 43.77925, lng: 11.24626, tz: 1 },
  "那不勒斯": { lat: 40.85216, lng: 14.26811, tz: 1 },
  "Naples": { lat: 40.85216, lng: 14.26811, tz: 1 },
  "都灵": { lat: 45.07049, lng: 7.68682, tz: 1 },
  "Turin": { lat: 45.07049, lng: 7.68682, tz: 1 },
  "博洛尼亚": { lat: 44.49381, lng: 11.33875, tz: 1 },
  "Bologna": { lat: 44.49381, lng: 11.33875, tz: 1 },
  "维罗纳": { lat: 45.43854, lng: 10.9938, tz: 1 },
  "Verona": { lat: 45.43854, lng: 10.9938, tz: 1 },
  "比萨": { lat: 43.70853, lng: 10.4036, tz: 1 },
  "Pisa": { lat: 43.70853, lng: 10.4036, tz: 1 },
  "马德里": { lat: 40.4165, lng: -3.70256, tz: 1 },
  "Madrid": { lat: 40.4165, lng: -3.70256, tz: 1 },
  "巴塞罗那": { lat: 41.38879, lng: 2.15899, tz: 1 },
  "Barcelona": { lat: 41.38879, lng: 2.15899, tz: 1 },
  "塞维利亚": { lat: 37.38283, lng: -5.97317, tz: 1 },
  "Seville": { lat: 37.38283, lng: -5.97317, tz: 1 },
  "瓦伦西亚": { lat: 39.47391, lng: -0.37966, tz: 1 },
  "Valencia": { lat: 39.47391, lng: -0.37966, tz: 1 },
  "马拉加": { lat: 36.72016, lng: -4.42034, tz: 1 },
  "Malaga": { lat: 36.72016, lng: -4.42034, tz: 1 },
  "格拉纳达": { lat: 37.18817, lng: -3.60667, tz: 1 },
  "Granada": { lat: 37.18817, lng: -3.60667, tz: 1 },
  "毕尔巴鄂": { lat: 43.26271, lng: -2.92528, tz: 1 },
  "Bilbao": { lat: 43.26271, lng: -2.92528, tz: 1 },
  "马略卡": { lat: 39.6953, lng: 3.0176, tz: 1 },
  "Mallorca": { lat: 39.6953, lng: 3.0176, tz: 1 },
  "阿姆斯特丹": { lat: 52.37403, lng: 4.88969, tz: 1 },
  "Amsterdam": { lat: 52.37403, lng: 4.88969, tz: 1 },
  "鹿特丹": { lat: 51.9225, lng: 4.47917, tz: 1 },
  "Rotterdam": { lat: 51.9225, lng: 4.47917, tz: 1 },
  "海牙": { lat: 52.07667, lng: 4.29861, tz: 1 },
  "The Hague": { lat: 52.07667, lng: 4.29861, tz: 1 },
  "乌得勒支": { lat: 52.09083, lng: 5.12222, tz: 1 },
  "Utrecht": { lat: 52.09083, lng: 5.12222, tz: 1 },
  "埃因霍温": { lat: 51.44083, lng: 5.47778, tz: 1 },
  "Eindhoven": { lat: 51.44083, lng: 5.47778, tz: 1 },
  "苏黎世": { lat: 47.36667, lng: 8.55, tz: 1 },
  "Zurich": { lat: 47.36667, lng: 8.55, tz: 1 },
  "日内瓦": { lat: 46.20222, lng: 6.14569, tz: 1 },
  "Geneva": { lat: 46.20222, lng: 6.14569, tz: 1 },
  "伯尔尼": { lat: 46.94809, lng: 7.44744, tz: 1 },
  "Bern": { lat: 46.94809, lng: 7.44744, tz: 1 },
  "巴塞尔": { lat: 47.55839, lng: 7.57327, tz: 1 },
  "Basel": { lat: 47.55839, lng: 7.57327, tz: 1 },
  "卢塞恩": { lat: 47.05048, lng: 8.30635, tz: 1 },
  "Lucerne": { lat: 47.05048, lng: 8.30635, tz: 1 },
  "洛桑": { lat: 46.516, lng: 6.63282, tz: 1 },
  "Lausanne": { lat: 46.516, lng: 6.63282, tz: 1 },
  "因特拉肯": { lat: 46.6863, lng: 7.8632, tz: 1 },
  "Interlaken": { lat: 46.6863, lng: 7.8632, tz: 1 },
  "莫斯科": { lat: 55.75204, lng: 37.61781, tz: 3 },
  "Moscow": { lat: 55.75204, lng: 37.61781, tz: 3 },
  "圣彼得堡": { lat: 59.93863, lng: 30.31413, tz: 3 },
  "Saint Petersburg": { lat: 59.93863, lng: 30.31413, tz: 3 },
  "新西伯利亚": { lat: 55.02259, lng: 82.93175, tz: 7 },
  "Novosibirsk": { lat: 55.02259, lng: 82.93175, tz: 7 },
  "叶卡捷琳堡": { lat: 56.8389, lng: 60.6057, tz: 5 },
  "Yekaterinburg": { lat: 56.8389, lng: 60.6057, tz: 5 },
  "喀山": { lat: 55.78874, lng: 49.12214, tz: 3 },
  "Kazan": { lat: 55.78874, lng: 49.12214, tz: 3 },
  "索契": { lat: 43.59699, lng: 39.72477, tz: 3 },
  "Sochi": { lat: 43.59699, lng: 39.72477, tz: 3 },
  "符拉迪沃斯托克": { lat: 43.1155, lng: 131.8855, tz: 10 },
  "Vladivostok": { lat: 43.1155, lng: 131.8855, tz: 10 },
  "里斯本": { lat: 38.72509, lng: -9.1498, tz: 0 },
  "Lisbon": { lat: 38.72509, lng: -9.1498, tz: 0 },
  "波尔图": { lat: 41.1579, lng: -8.6291, tz: 0 },
  "Porto": { lat: 41.1579, lng: -8.6291, tz: 0 },
  "法鲁": { lat: 37.0194, lng: -7.9304, tz: 0 },
  "Faro": { lat: 37.0194, lng: -7.9304, tz: 0 },
  "科英布拉": { lat: 40.20686, lng: -8.41996, tz: 0 },
  "Coimbra": { lat: 40.20686, lng: -8.41996, tz: 0 },
  "马德拉": { lat: 32.7607, lng: -16.9595, tz: 0 },
  "Madeira": { lat: 32.7607, lng: -16.9595, tz: 0 },
  "雅典": { lat: 37.98376, lng: 23.72784, tz: 2 },
  "Athens": { lat: 37.98376, lng: 23.72784, tz: 2 },
  "塞萨洛尼基": { lat: 40.64072, lng: 22.93493, tz: 2 },
  "Thessaloniki": { lat: 40.64072, lng: 22.93493, tz: 2 },
  "圣托里尼": { lat: 36.3932, lng: 25.4615, tz: 2 },
  "Santorini": { lat: 36.3932, lng: 25.4615, tz: 2 },
  "米科诺斯": { lat: 37.4467, lng: 25.3289, tz: 2 },
  "Mykonos": { lat: 37.4467, lng: 25.3289, tz: 2 },
  "克里特": { lat: 35.2401, lng: 24.8093, tz: 2 },
  "Crete": { lat: 35.2401, lng: 24.8093, tz: 2 },
  "斯德哥尔摩": { lat: 59.32938, lng: 18.06871, tz: 1 },
  "Stockholm": { lat: 59.32938, lng: 18.06871, tz: 1 },
  "哥德堡": { lat: 57.70716, lng: 11.96679, tz: 1 },
  "Gothenburg": { lat: 57.70716, lng: 11.96679, tz: 1 },
  "马尔默": { lat: 55.60587, lng: 13.00073, tz: 1 },
  "Malmo": { lat: 55.60587, lng: 13.00073, tz: 1 },
  "乌普萨拉": { lat: 59.85882, lng: 17.63889, tz: 1 },
  "Uppsala": { lat: 59.85882, lng: 17.63889, tz: 1 },
  "奥斯陆": { lat: 59.91273, lng: 10.74609, tz: 1 },
  "Oslo": { lat: 59.91273, lng: 10.74609, tz: 1 },
  "卑尔根": { lat: 60.3913, lng: 5.3221, tz: 1 },
  "Bergen": { lat: 60.3913, lng: 5.3221, tz: 1 },
  "特隆赫姆": { lat: 63.43049, lng: 10.39506, tz: 1 },
  "Trondheim": { lat: 63.43049, lng: 10.39506, tz: 1 },
  "特罗姆瑟": { lat: 69.6489, lng: 18.95508, tz: 1 },
  "Tromso": { lat: 69.6489, lng: 18.95508, tz: 1 },
  "维也纳": { lat: 48.2082, lng: 16.3738, tz: 1 },
  "Vienna": { lat: 48.2082, lng: 16.3738, tz: 1 },
  "萨尔茨堡": { lat: 47.79941, lng: 13.04399, tz: 1 },
  "Salzburg": { lat: 47.79941, lng: 13.04399, tz: 1 },
  "因斯布鲁克": { lat: 47.26266, lng: 11.39454, tz: 1 },
  "Innsbruck": { lat: 47.26266, lng: 11.39454, tz: 1 },
  "格拉茨": { lat: 47.06733, lng: 15.44197, tz: 1 },
  "Graz": { lat: 47.06733, lng: 15.44197, tz: 1 },
  "布鲁塞尔": { lat: 50.85045, lng: 4.34878, tz: 1 },
  "Brussels": { lat: 50.85045, lng: 4.34878, tz: 1 },
  "安特卫普": { lat: 51.22047, lng: 4.40026, tz: 1 },
  "Antwerp": { lat: 51.22047, lng: 4.40026, tz: 1 },
  "布鲁日": { lat: 51.20892, lng: 3.22424, tz: 1 },
  "Bruges": { lat: 51.20892, lng: 3.22424, tz: 1 },
  "根特": { lat: 51.05, lng: 3.71667, tz: 1 },
  "Ghent": { lat: 51.05, lng: 3.71667, tz: 1 },
  "哥本哈根": { lat: 55.67594, lng: 12.56553, tz: 1 },
  "Copenhagen": { lat: 55.67594, lng: 12.56553, tz: 1 },
  "奥胡斯": { lat: 56.15674, lng: 10.21076, tz: 1 },
  "Aarhus": { lat: 56.15674, lng: 10.21076, tz: 1 },
  "欧登塞": { lat: 55.39594, lng: 10.38831, tz: 1 },
  "Odense": { lat: 55.39594, lng: 10.38831, tz: 1 },
  "赫尔辛基": { lat: 60.16952, lng: 24.93545, tz: 2 },
  "Helsinki": { lat: 60.16952, lng: 24.93545, tz: 2 },
  "坦佩雷": { lat: 61.49911, lng: 23.78712, tz: 2 },
  "Tampere": { lat: 61.49911, lng: 23.78712, tz: 2 },
  "图尔库": { lat: 60.45148, lng: 22.26869, tz: 2 },
  "Turku": { lat: 60.45148, lng: 22.26869, tz: 2 },
  "罗瓦涅米": { lat: 66.49897, lng: 25.68867, tz: 2 },
  "Rovaniemi": { lat: 66.49897, lng: 25.68867, tz: 2 },
  "都柏林": { lat: 53.33306, lng: -6.24889, tz: 0 },
  "Dublin": { lat: 53.33306, lng: -6.24889, tz: 0 },
  "科克": { lat: 51.89797, lng: -8.47061, tz: 0 },
  "Cork": { lat: 51.89797, lng: -8.47061, tz: 0 },
  "戈尔韦": { lat: 53.27245, lng: -9.05095, tz: 0 },
  "Galway": { lat: 53.27245, lng: -9.05095, tz: 0 },
  "布拉格": { lat: 50.08804, lng: 14.42076, tz: 1 },
  "Prague": { lat: 50.08804, lng: 14.42076, tz: 1 },
  "布尔诺": { lat: 49.1951, lng: 16.6068, tz: 1 },
  "Brno": { lat: 49.1951, lng: 16.6068, tz: 1 },
  "卡罗维发利": { lat: 50.23271, lng: 12.87117, tz: 1 },
  "Karlovy Vary": { lat: 50.23271, lng: 12.87117, tz: 1 },
  "华沙": { lat: 52.22977, lng: 21.01178, tz: 1 },
  "Warsaw": { lat: 52.22977, lng: 21.01178, tz: 1 },
  "克拉科夫": { lat: 50.06143, lng: 19.93658, tz: 1 },
  "Krakow": { lat: 50.06143, lng: 19.93658, tz: 1 },
  "格但斯克": { lat: 54.35227, lng: 18.64912, tz: 1 },
  "Gdansk": { lat: 54.35227, lng: 18.64912, tz: 1 },
  "弗罗茨瓦夫": { lat: 51.10286, lng: 17.03006, tz: 1 },
  "Wroclaw": { lat: 51.10286, lng: 17.03006, tz: 1 },
  "布达佩斯": { lat: 47.49835, lng: 19.04045, tz: 1 },
  "Budapest": { lat: 47.49835, lng: 19.04045, tz: 1 },
  "德布勒森": { lat: 47.53167, lng: 21.62444, tz: 1 },
  "Debrecen": { lat: 47.53167, lng: 21.62444, tz: 1 },
  "萨格勒布": { lat: 45.81444, lng: 15.97798, tz: 1 },
  "Zagreb": { lat: 45.81444, lng: 15.97798, tz: 1 },
  "杜布罗夫尼克": { lat: 42.6507, lng: 18.0944, tz: 1 },
  "Dubrovnik": { lat: 42.6507, lng: 18.0944, tz: 1 },
  "斯普利特": { lat: 43.50891, lng: 16.43915, tz: 1 },
  "Split": { lat: 43.50891, lng: 16.43915, tz: 1 },
  "雷克雅未克": { lat: 64.13548, lng: -21.89541, tz: 0 },
  "Reykjavik": { lat: 64.13548, lng: -21.89541, tz: 0 },
  "阿克雷里": { lat: 65.68353, lng: -18.0878, tz: 0 },
  "Akureyri": { lat: 65.68353, lng: -18.0878, tz: 0 },
  "卢森堡市": { lat: 49.6116, lng: 6.1319, tz: 1 },
  "Luxembourg City": { lat: 49.6116, lng: 6.1319, tz: 1 },
  "纽约": { lat: 40.71399, lng: -73.55902, tz: -5 },
  "New York": { lat: 40.71399, lng: -73.55902, tz: -5 },
  "洛杉矶": { lat: 34.05223, lng: -118.24368, tz: -8 },
  "Los Angeles": { lat: 34.05223, lng: -118.24368, tz: -8 },
  "芝加哥": { lat: 41.85003, lng: -87.65005, tz: -6 },
  "Chicago": { lat: 41.85003, lng: -87.65005, tz: -6 },
  "休斯顿": { lat: 29.76328, lng: -95.36327, tz: -6 },
  "Houston": { lat: 29.76328, lng: -95.36327, tz: -6 },
  "旧金山": { lat: 37.77493, lng: -122.41942, tz: -8 },
  "San Francisco": { lat: 37.77493, lng: -122.41942, tz: -8 },
  "西雅图": { lat: 47.6062, lng: -122.3321, tz: -8 },
  "Seattle": { lat: 47.6062, lng: -122.3321, tz: -8 },
  "波士顿": { lat: 42.35843, lng: -71.05977, tz: -5 },
  "Boston": { lat: 42.35843, lng: -71.05977, tz: -5 },
  "迈阿密": { lat: 25.77427, lng: -80.19366, tz: -5 },
  "Miami": { lat: 25.77427, lng: -80.19366, tz: -5 },
  "拉斯维加斯": { lat: 36.17497, lng: -115.13722, tz: -8 },
  "Las Vegas": { lat: 36.17497, lng: -115.13722, tz: -8 },
  "华盛顿": { lat: 38.90723, lng: -77.03687, tz: -5 },
  "Washington D.C.": { lat: 38.90723, lng: -77.03687, tz: -5 },
  "奥兰多": { lat: 28.53834, lng: -81.37924, tz: -5 },
  "Orlando": { lat: 28.53834, lng: -81.37924, tz: -5 },
  "达拉斯": { lat: 32.7767, lng: -96.797, tz: -6 },
  "Dallas": { lat: 32.7767, lng: -96.797, tz: -6 },
  "亚特兰大": { lat: 33.749, lng: -84.38798, tz: -5 },
  "Atlanta": { lat: 33.749, lng: -84.38798, tz: -5 },
  "费城": { lat: 39.95238, lng: -75.16362, tz: -5 },
  "Philadelphia": { lat: 39.95238, lng: -75.16362, tz: -5 },
  "圣地亚哥": { lat: -33.45694, lng: -70.64827, tz: -4 },
  "San Diego": { lat: 32.7157, lng: -117.1611, tz: -8 },
  "丹佛": { lat: 39.73915, lng: -104.9847, tz: -7 },
  "Denver": { lat: 39.73915, lng: -104.9847, tz: -7 },
  "夏威夷檀香山": { lat: 21.30694, lng: -157.85833, tz: -10 },
  "Honolulu": { lat: 21.30694, lng: -157.85833, tz: -10 },
  "多伦多": { lat: 43.70643, lng: -79.39864, tz: -5 },
  "Toronto": { lat: 43.70643, lng: -79.39864, tz: -5 },
  "温哥华": { lat: 49.2827, lng: -123.1207, tz: -8 },
  "Vancouver": { lat: 49.2827, lng: -123.1207, tz: -8 },
  "蒙特利尔": { lat: 45.50884, lng: -73.58781, tz: -5 },
  "Montreal": { lat: 45.50884, lng: -73.58781, tz: -5 },
  "卡尔加里": { lat: 51.05011, lng: -114.08529, tz: -7 },
  "Calgary": { lat: 51.05011, lng: -114.08529, tz: -7 },
  "渥太华": { lat: 45.4215, lng: -75.6972, tz: -5 },
  "Ottawa": { lat: 45.4215, lng: -75.6972, tz: -5 },
  "魁北克城": { lat: 46.8139, lng: -71.208, tz: -5 },
  "Quebec City": { lat: 46.8139, lng: -71.208, tz: -5 },
  "埃德蒙顿": { lat: 53.55014, lng: -113.46871, tz: -7 },
  "Edmonton": { lat: 53.55014, lng: -113.46871, tz: -7 },
  "温尼伯": { lat: 49.8844, lng: -97.14704, tz: -6 },
  "Winnipeg": { lat: 49.8844, lng: -97.14704, tz: -6 },
  "墨西哥城": { lat: 19.42847, lng: -99.12766, tz: -6 },
  "Mexico City": { lat: 19.42847, lng: -99.12766, tz: -6 },
  "瓜达拉哈拉": { lat: 20.67738, lng: -103.34749, tz: -6 },
  "Guadalajara": { lat: 20.67738, lng: -103.34749, tz: -6 },
  "蒙特雷": { lat: 25.68435, lng: -100.31721, tz: -6 },
  "Monterrey": { lat: 25.68435, lng: -100.31721, tz: -6 },
  "坎昆": { lat: 21.17429, lng: -86.84656, tz: -5 },
  "Cancun": { lat: 21.17429, lng: -86.84656, tz: -5 },
  "蒂华纳": { lat: 32.5149, lng: -117.0382, tz: -8 },
  "Tijuana": { lat: 32.5149, lng: -117.0382, tz: -8 },
  "梅里达": { lat: 20.967, lng: -89.62318, tz: -6 },
  "Merida": { lat: 20.967, lng: -89.62318, tz: -6 },
  "哈瓦那": { lat: 23.13302, lng: -82.38304, tz: -5 },
  "Havana": { lat: 23.13302, lng: -82.38304, tz: -5 },
  "巴拉德罗": { lat: 23.1799, lng: -81.1885, tz: -5 },
  "Varadero": { lat: 23.1799, lng: -81.1885, tz: -5 },
  "巴拿马城": { lat: 8.9824, lng: -79.5199, tz: -5 },
  "Panama City": { lat: 8.9824, lng: -79.5199, tz: -5 },
  "圣何塞": { lat: 9.9281, lng: -84.0907, tz: -6 },
  "San Jose": { lat: 9.9281, lng: -84.0907, tz: -6 },
  "圣多明各": { lat: 18.4861, lng: -69.9312, tz: -4 },
  "Santo Domingo": { lat: 18.4861, lng: -69.9312, tz: -4 },
  "蓬塔卡纳": { lat: 18.5601, lng: -68.3725, tz: -4 },
  "Punta Cana": { lat: 18.5601, lng: -68.3725, tz: -4 },
  "布宜诺斯艾利斯": { lat: -34.61315, lng: -58.37723, tz: -3 },
  "Buenos Aires": { lat: -34.61315, lng: -58.37723, tz: -3 },
  "科尔多瓦": { lat: -31.40648, lng: -64.18853, tz: -3 },
  "Cordoba": { lat: -31.40648, lng: -64.18853, tz: -3 },
  "罗萨里奥": { lat: -32.94682, lng: -60.63932, tz: -3 },
  "Rosario": { lat: -32.94682, lng: -60.63932, tz: -3 },
  "门多萨": { lat: -32.88946, lng: -68.84582, tz: -3 },
  "Mendoza": { lat: -32.88946, lng: -68.84582, tz: -3 },
  "Santiago": { lat: -33.45694, lng: -70.64827, tz: -4 },
  "瓦尔帕莱索": { lat: -33.036, lng: -71.62963, tz: -4 },
  "Valparaiso": { lat: -33.036, lng: -71.62963, tz: -4 },
  "蓬塔阿雷纳斯": { lat: -53.16282, lng: -70.90922, tz: -3 },
  "Punta Arenas": { lat: -53.16282, lng: -70.90922, tz: -3 },
  "波哥大": { lat: 4.60971, lng: -74.08175, tz: -5 },
  "Bogota": { lat: 4.60971, lng: -74.08175, tz: -5 },
  "麦德林": { lat: 6.245, lng: -75.57151, tz: -5 },
  "Medellin": { lat: 6.245, lng: -75.57151, tz: -5 },
  "卡利": { lat: 3.43054, lng: -76.5199, tz: -5 },
  "Cali": { lat: 3.43054, lng: -76.5199, tz: -5 },
  "卡塔赫纳": { lat: 10.39817, lng: -75.49328, tz: -5 },
  "Cartagena": { lat: 10.39817, lng: -75.49328, tz: -5 },
  "利马": { lat: -12.0464, lng: -77.0428, tz: -5 },
  "Lima": { lat: -12.0464, lng: -77.0428, tz: -5 },
  "库斯科": { lat: -13.5319, lng: -71.9675, tz: -5 },
  "Cusco": { lat: -13.5319, lng: -71.9675, tz: -5 },
  "阿雷基帕": { lat: -16.39899, lng: -71.53747, tz: -5 },
  "Arequipa": { lat: -16.39899, lng: -71.53747, tz: -5 },
  "圣保罗": { lat: -23.5475, lng: -46.63611, tz: -3 },
  "Sao Paulo": { lat: -23.5475, lng: -46.63611, tz: -3 },
  "里约热内卢": { lat: -22.90642, lng: -43.18223, tz: -3 },
  "Rio de Janeiro": { lat: -22.90642, lng: -43.18223, tz: -3 },
  "巴西利亚": { lat: -15.77972, lng: -47.92972, tz: -3 },
  "Brasilia": { lat: -15.77972, lng: -47.92972, tz: -3 },
  "萨尔瓦多": { lat: -12.97563, lng: -38.49096, tz: -3 },
  "Salvador": { lat: -12.97563, lng: -38.49096, tz: -3 },
  "福塔莱萨": { lat: -3.7319, lng: -38.5267, tz: -3 },
  "Fortaleza": { lat: -3.7319, lng: -38.5267, tz: -3 },
  "累西腓": { lat: -8.05389, lng: -34.88111, tz: -3 },
  "Recife": { lat: -8.05389, lng: -34.88111, tz: -3 },
  "库里蒂巴": { lat: -25.4284, lng: -49.2733, tz: -3 },
  "Curitiba": { lat: -25.4284, lng: -49.2733, tz: -3 },
  "基多": { lat: -0.22985, lng: -78.52495, tz: -5 },
  "Quito": { lat: -0.22985, lng: -78.52495, tz: -5 },
  "瓜亚基尔": { lat: -2.171, lng: -79.9224, tz: -5 },
  "Guayaquil": { lat: -2.171, lng: -79.9224, tz: -5 },
  "蒙得维的亚": { lat: -34.90328, lng: -56.18816, tz: -3 },
  "Montevideo": { lat: -34.90328, lng: -56.18816, tz: -3 },
  "埃斯特角城": { lat: -34.9369, lng: -54.9368, tz: -3 },
  "Punta del Este": { lat: -34.9369, lng: -54.9368, tz: -3 },
  "加拉加斯": { lat: 10.4806, lng: -66.9036, tz: -4 },
  "Caracas": { lat: 10.4806, lng: -66.9036, tz: -4 },
  "马拉开波": { lat: 10.64232, lng: -71.61089, tz: -4 },
  "Maracaibo": { lat: 10.64232, lng: -71.61089, tz: -4 },
  "奥克兰": { lat: -36.8509, lng: 174.7645, tz: 12 },
  "Auckland": { lat: -36.8509, lng: 174.7645, tz: 12 },
  "惠灵顿": { lat: -41.28664, lng: 174.77557, tz: 12 },
  "Wellington": { lat: -41.28664, lng: 174.77557, tz: 12 },
  "基督城": { lat: -43.53333, lng: 172.63333, tz: 12 },
  "Christchurch": { lat: -43.53333, lng: 172.63333, tz: 12 },
  "皇后镇": { lat: -45.0312, lng: 168.6626, tz: 12 },
  "Queenstown": { lat: -45.0312, lng: 168.6626, tz: 12 },
  "罗托鲁瓦": { lat: -38.1368, lng: 176.2497, tz: 12 },
  "Rotorua": { lat: -38.1368, lng: 176.2497, tz: 12 },
  "但尼丁": { lat: -45.87416, lng: 170.50361, tz: 12 },
  "Dunedin": { lat: -45.87416, lng: 170.50361, tz: 12 },
  "苏瓦": { lat: -18.1248, lng: 178.4501, tz: 12 },
  "Suva": { lat: -18.1248, lng: 178.4501, tz: 12 },
  "楠迪": { lat: -17.80309, lng: 177.41617, tz: 12 },
  "Nadi": { lat: -17.80309, lng: 177.41617, tz: 12 },
  "悉尼": { lat: -33.86785, lng: 151.20732, tz: 10 },
  "Sydney": { lat: -33.86785, lng: 151.20732, tz: 10 },
  "墨尔本": { lat: -37.814, lng: 144.96332, tz: 10 },
  "Melbourne": { lat: -37.814, lng: 144.96332, tz: 10 },
  "布里斯班": { lat: -27.46794, lng: 153.02809, tz: 10 },
  "Brisbane": { lat: -27.46794, lng: 153.02809, tz: 10 },
  "珀斯": { lat: -31.95224, lng: 115.8614, tz: 8 },
  "Perth": { lat: -31.95224, lng: 115.8614, tz: 8 },
  "阿德莱德": { lat: -34.92866, lng: 138.59863, tz: 9.5 },
  "Adelaide": { lat: -34.92866, lng: 138.59863, tz: 9.5 },
  "堪培拉": { lat: -35.28346, lng: 149.12807, tz: 10 },
  "Canberra": { lat: -35.28346, lng: 149.12807, tz: 10 },
  "黄金海岸": { lat: -28.0167, lng: 153.4, tz: 10 },
  "Gold Coast": { lat: -28.0167, lng: 153.4, tz: 10 },
  "凯恩斯": { lat: -16.92366, lng: 145.76613, tz: 10 },
  "Cairns": { lat: -16.92366, lng: 145.76613, tz: 10 },
  "达尔文": { lat: -12.46113, lng: 130.84185, tz: 9.5 },
  "Darwin": { lat: -12.46113, lng: 130.84185, tz: 9.5 },
  "霍巴特": { lat: -42.87936, lng: 147.32941, tz: 10 },
  "Hobart": { lat: -42.87936, lng: 147.32941, tz: 10 },
  "莫尔兹比港": { lat: -9.47723, lng: 147.15089, tz: 10 },
  "Port Moresby": { lat: -9.47723, lng: 147.15089, tz: 10 },
  "帕皮提": { lat: -17.5516, lng: -149.5585, tz: -10 },
  "Papeete": { lat: -17.5516, lng: -149.5585, tz: -10 },
  "约翰内斯堡": { lat: -26.20227, lng: 28.04363, tz: 2 },
  "Johannesburg": { lat: -26.20227, lng: 28.04363, tz: 2 },
  "开普敦": { lat: -33.9249, lng: 18.4241, tz: 2 },
  "Cape Town": { lat: -33.9249, lng: 18.4241, tz: 2 },
  "德班": { lat: -29.8579, lng: 31.0292, tz: 2 },
  "Durban": { lat: -29.8579, lng: 31.0292, tz: 2 },
  "比勒陀利亚": { lat: -25.74486, lng: 28.18783, tz: 2 },
  "Pretoria": { lat: -25.74486, lng: 28.18783, tz: 2 },
  "伊丽莎白港": { lat: -33.9608, lng: 25.6022, tz: 2 },
  "Port Elizabeth": { lat: -33.9608, lng: 25.6022, tz: 2 },
  "开罗": { lat: 30.06263, lng: 31.24967, tz: 2 },
  "Cairo": { lat: 30.06263, lng: 31.24967, tz: 2 },
  "亚历山大": { lat: 31.20176, lng: 29.91582, tz: 2 },
  "Alexandria": { lat: 31.20176, lng: 29.91582, tz: 2 },
  "卢克索": { lat: 25.6872, lng: 32.6396, tz: 2 },
  "Luxor": { lat: 25.6872, lng: 32.6396, tz: 2 },
  "阿斯旺": { lat: 24.09082, lng: 32.89942, tz: 2 },
  "Aswan": { lat: 24.09082, lng: 32.89942, tz: 2 },
  "沙姆沙伊赫": { lat: 27.9158, lng: 34.3299, tz: 2 },
  "Sharm El Sheikh": { lat: 27.9158, lng: 34.3299, tz: 2 },
  "赫尔格达": { lat: 27.2579, lng: 33.8116, tz: 2 },
  "Hurghada": { lat: 27.2579, lng: 33.8116, tz: 2 },
  "卡萨布兰卡": { lat: 33.58831, lng: -7.61138, tz: 1 },
  "Casablanca": { lat: 33.58831, lng: -7.61138, tz: 1 },
  "马拉喀什": { lat: 31.63416, lng: -7.99994, tz: 1 },
  "Marrakech": { lat: 31.63416, lng: -7.99994, tz: 1 },
  "拉巴特": { lat: 34.01325, lng: -6.83255, tz: 1 },
  "Rabat": { lat: 34.01325, lng: -6.83255, tz: 1 },
  "非斯": { lat: 34.0181, lng: -5.0078, tz: 1 },
  "Fez": { lat: 34.0181, lng: -5.0078, tz: 1 },
  "丹吉尔": { lat: 35.7595, lng: -5.834, tz: 1 },
  "Tangier": { lat: 35.7595, lng: -5.834, tz: 1 },
  "内罗毕": { lat: -1.28333, lng: 36.81667, tz: 3 },
  "Nairobi": { lat: -1.28333, lng: 36.81667, tz: 3 },
  "蒙巴萨": { lat: -4.05466, lng: 39.66359, tz: 3 },
  "Mombasa": { lat: -4.05466, lng: 39.66359, tz: 3 },
  "拉各斯": { lat: 6.5244, lng: 3.3792, tz: 1 },
  "Lagos": { lat: 6.5244, lng: 3.3792, tz: 1 },
  "阿布贾": { lat: 9.05785, lng: 7.49508, tz: 1 },
  "Abuja": { lat: 9.05785, lng: 7.49508, tz: 1 },
  "卡诺": { lat: 12.0022, lng: 8.592, tz: 1 },
  "Kano": { lat: 12.0022, lng: 8.592, tz: 1 },
  "达累斯萨拉姆": { lat: -6.82349, lng: 39.26951, tz: 3 },
  "Dar es Salaam": { lat: -6.82349, lng: 39.26951, tz: 3 },
  "阿鲁沙": { lat: -3.36667, lng: 36.68333, tz: 3 },
  "Arusha": { lat: -3.36667, lng: 36.68333, tz: 3 },
  "桑给巴尔": { lat: -6.1659, lng: 39.2026, tz: 3 },
  "Zanzibar": { lat: -6.1659, lng: 39.2026, tz: 3 },
  "路易港": { lat: -20.16194, lng: 57.49889, tz: 4 },
  "Port Louis": { lat: -20.16194, lng: 57.49889, tz: 4 },
  "维多利亚": { lat: -4.62001, lng: 55.45501, tz: 4 },
  "Victoria": { lat: -4.62001, lng: 55.45501, tz: 4 },
  "突尼斯市": { lat: 36.81897, lng: 10.16579, tz: 1 },
  "Tunis": { lat: 36.81897, lng: 10.16579, tz: 1 },
  "苏塞": { lat: 35.82539, lng: 10.63699, tz: 1 },
  "Sousse": { lat: 35.82539, lng: 10.63699, tz: 1 },
  "阿尔及尔": { lat: 36.7538, lng: 3.0588, tz: 1 },
  "Algiers": { lat: 36.7538, lng: 3.0588, tz: 1 },
  "奥兰": { lat: 35.6971, lng: -0.6308, tz: 1 },
  "Oran": { lat: 35.6971, lng: -0.6308, tz: 1 },
  "亚的斯亚贝巴": { lat: 8.9806, lng: 38.7578, tz: 3 },
  "Addis Ababa": { lat: 8.9806, lng: 38.7578, tz: 3 },
  "阿克拉": { lat: 5.55602, lng: -0.1969, tz: 0 },
  "Accra": { lat: 5.55602, lng: -0.1969, tz: 0 },
  "库马西": { lat: 6.68848, lng: -1.62443, tz: 0 },
  "Kumasi": { lat: 6.68848, lng: -1.62443, tz: 0 },
};

export const PROVINCE_COORDS: Record<string, { lat: number; lng: number }> = {
  "北京市": { lat: 39.928359, lng: 116.416334 },
  "天津市": { lat: 39.116884, lng: 117.214713 },
  "河北省": { lat: 38.03682, lng: 114.538955 },
  "山西省": { lat: 37.736865, lng: 112.565524 },
  "内蒙古自治区": { lat: 40.858271, lng: 111.665325 },
  "辽宁省": { lat: 41.789766, lng: 123.420401 },
  "吉林省": { lat: 43.495116, lng: 124.79379 },
  "黑龙江省": { lat: 45.755832, lng: 126.616912 },
  "上海市": { lat: 31.231661, lng: 121.48442 },
  "江苏省": { lat: 32.048644, lng: 118.797779 },
  "浙江省": { lat: 30.226543, lng: 120.19732 },
  "安徽省": { lat: 31.858111, lng: 117.30944 },
  "福建省": { lat: 26.082666, lng: 119.304507 },
  "江西省": { lat: 28.698787, lng: 115.903576 },
  "山东省": { lat: 36.666395, lng: 117.07632 },
  "河南省": { lat: 34.74828, lng: 113.612966 },
  "湖北省": { lat: 30.633093, lng: 114.282987 },
  "湖南省": { lat: 28.185351, lng: 113.032605 },
  "广东省": { lat: 23.107123, lng: 113.218998 },
  "广西壮族自治区": { lat: 22.85354, lng: 108.368071 },
  "海南省": { lat: 20.007703, lng: 110.293566 },
  "重庆市": { lat: 30.807621, lng: 108.408591 },
  "四川省": { lat: 30.598726, lng: 104.117262 },
  "贵州省": { lat: 26.568055, lng: 106.714305 },
  "云南省": { lat: 25.043635, lng: 102.707262 },
  "西藏自治区": { lat: 29.654813, lng: 91.140368 },
  "陕西省": { lat: 34.266601, lng: 108.960707 },
  "甘肃省": { lat: 36.056948, lng: 103.825315 },
  "青海省": { lat: 36.599744, lng: 101.803717 },
  "宁夏回族自治区": { lat: 38.473972, lng: 106.288452 },
  "新疆维吾尔自治区": { lat: 43.794312, lng: 87.631986 },
  "香港特别行政区": { lat: 22.282, lng: 114.154 },
  "澳门特别行政区": { lat: 22.211, lng: 113.552 },
  "台湾": { lat: 25.0503, lng: 121.5775 },
};
